// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Agent — 에이전트 빌더 영역
   사이드바·인트로·필터 공통 스타일은 Prompt.css 재사용
   ======================================================================== */

/* ───────── 사이드바 — 대화 목록 섹션 추가 ───────── */
.agent__sidebar {
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  max-height: calc(100vh - 52px);
  overflow: hidden;
}

.agent__sidebar-chats {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--fg-line);
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-height: 0;
}

.agent__sidebar-section-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent__sidebar-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 6px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
}

.agent__sidebar-search-input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 13px;
  background: transparent;
  color: var(--fg-text-basic);
}

.agent__sidebar-search-input::placeholder {
  color: var(--fg-text-gray);
}

.agent__sidebar-search>svg {
  flex-shrink: 0;
  color: var(--fg-text-gray);
}

.agent__sidebar-chat-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.agent__sidebar-chat-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  background: #fff;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent__sidebar-chat-item:hover,
.agent__sidebar-chat-item--active {
  background: var(--fg-bg-liteblue);
  border-color: var(--fg-button-hover);
}

.agent__sidebar-chat-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: #fff;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.agent__sidebar-chat-item:hover .agent__sidebar-chat-delete,
.agent__sidebar-chat-item--active .agent__sidebar-chat-delete {
  visibility: visible;
  opacity: 1;
}

.agent__sidebar-chat-delete:hover {
  color: var(--fg-anti-red);
  background: rgba(0, 0, 0, 0.04);
}

.agent__sidebar-chat-icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  color: var(--fg-text-purple);
  margin-top: 2px;
}

.agent__sidebar-chat-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agent__sidebar-chat-eyebrow {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-purple);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent__sidebar-chat-title {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #464646;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent__sidebar-chat-time {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}

.agent__sidebar-chat-empty {
  padding: 8px;
  font-size: 13px;
  color: var(--fg-text-gray);
  text-align: center;
}

/* ───────── AgentList 폴더 탭 ───────── */
.agent-list__folder-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin: 12px 0 16px;
}

.agent-list__folder-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 2px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-list__folder-tab:hover {
  color: var(--fg-text-basic);
}

.agent-list__folder-tab--active {
  color: var(--fg-text-basic);
  border-bottom-color: var(--fg-text-basic);
  font-weight: 600;
}

.agent-list__folder-tab-count {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

/* ───────── AgentList 카드 ───────── */
.agent-list__cards {
  display: grid;
  gap: 20px;
  grid-auto-rows: 1fr;
  align-items: stretch;
}

.agent-list__cards--grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.agent-list__cards--list {
  grid-template-columns: 1fr;
}

@media (max-width: 1280px) {
  .agent-list__cards--grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.agent-list__card {
  display: flex;
  gap: 12px;
  padding: 16px 20px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
  height: 100%;
  min-height: 240px;
  box-sizing: border-box;
}

.agent-list__card:hover {
  border-color: var(--fg-button);
}

.agent-list__card--selected {
  border-color: var(--fg-side-hover);
  box-shadow: 0 0 0 1px var(--fg-side-hover);
}

.agent-list__card-check {
  flex-shrink: 0;
  padding-top: 3px;
}

.agent-list__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agent-list__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agent-list__card-title {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-list__card-date {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.agent-list__card-summary {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 44px;
  word-break: break-word;
}

/* 대화/발행 액션 */
.agent-list__card-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.agent-list__action {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 20px;
  background: var(--fg-bg-mychat);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-button-hover);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-list__action:hover {
  background: #d8dbed;
}

.agent-list__action--publishing {
  background: #c7ffeb;
  border-color: #c7ffeb;
  color: var(--fg-text-basic);
  padding: 14px 20px;
}

.agent-list__action--publishing:hover {
  background: #b3f5dc;
  border-color: #b3f5dc;
}

/* 카드 footer (폴더 칩 좌측 + 공유/삭제 우측) */
.agent-list__card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  min-height: 28px;
}

.agent-list__card-folders {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
}

.agent-list__card-folder-chip {
  display: inline-flex;
  align-items: center;
  max-width: 80px;
  height: 20px;
  padding: 0 8px;
  background: var(--fg-bg-mychat);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: var(--fg-button-hover);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

.agent-list__card-folder-chip--more {
  padding: 0 6px;
  background: transparent;
  color: var(--fg-text-gray);
}

.agent-list__card-footer-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* ========================================================================
   AgentCreate — 새 에이전트 만들기 (Figma 76:7049)
   ======================================================================== */

.agent-create__main {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-create__center {
  width: 100%;
  max-width: 760px;
  padding: 60px 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.agent-create__title {
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  text-align: left;
  color: var(--fg-text-basic);
  line-height: 46px;
}

.agent-create__subtitle {
  margin: 10px 0 40px;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
  text-align: left;
}

.agent-create__input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2);
}

.agent-create__input {
  flex: 1 1;
  min-width: 0;
  min-height: 26px;
  max-height: 160px;
  border: 0;
  outline: none;
  resize: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  background: transparent;
  padding: 0;
  overflow-y: hidden;
}

.agent-create__input::placeholder {
  color: var(--fg-text-gray);
}

.agent-create__send {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--fg-button);
  padding: 0;
}

.agent-create__send:hover {
  color: var(--fg-button-hover);
}

.agent-create__send:disabled {
  color: var(--fg-text-gray);
  cursor: not-allowed;
}

.agent-create__input:disabled {
  cursor: not-allowed;
}

.agent-create__status {
  margin: 14px 0 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: center;
  padding: 8px 14px;
  background: var(--fg-bg-card, #f5f5f7);
  border-radius: 999px;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.agent-create__presets {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  margin-top: 20px;
}

/* 질문 단계 — 가운데 정렬 + 카드 폼 */
.agent-create__center--questions {
  padding-top: 80px;
}

.agent-create__qheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.agent-create__qhint {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.agent-create__qrestart {
  background: transparent;
  border: 0;
  padding: 0;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-button);
  cursor: pointer;
}

.agent-create__qrestart:hover {
  color: var(--fg-button-hover);
  text-decoration: underline;
}

.agent-create__qcard {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  padding: 20px;
  animation: agent-qcard-in 200ms ease-out;
}

.agent-create__qcard-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

@keyframes agent-qcard-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agent-create__qcard-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  color: var(--fg-text-basic, #3b3b3b);
  word-break: keep-all;
}

.agent-create__qcard-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

.agent-create__qopts {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  width: 100%;
}

.agent-create__qopt {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  transition: opacity 120ms ease;
}

.agent-create__qopt:hover .agent-create__qopt-box {
  border-color: var(--fg-button, #978cca);
}

.agent-create__qopt-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}

.agent-create__qopt-box {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: var(--gray---c2c2c2, #c2c2c2);
  border: 0;
  border-radius: 4px;
  color: #fff;
  transition: background-color 120ms ease;
}

.agent-create__qopt-box>svg {
  visibility: hidden;
}

.agent-create__qopt-input:checked+.agent-create__qopt-box {
  background: var(--fg-button, #978cca);
}

.agent-create__qopt-input:checked+.agent-create__qopt-box>svg {
  visibility: visible;
}

.agent-create__qopt-label {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
  white-space: nowrap;
}

.agent-create__qfooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 0;
  border: 0;
}

.agent-create__qfooter-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agent-create__qfooter-page {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray, #838383);
}

.agent-create__qfooter-back,
.agent-create__qfooter-skip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 4px;
  background: transparent;
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.agent-create__qfooter-back:hover:not(:disabled),
.agent-create__qfooter-skip:hover {
  background: var(--fg-bg-litepp, #e8eaf5);
  color: var(--fg-text-purple, #7362c2);
}

.agent-create__qfooter-back:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.agent-create__qfooter-next {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 5px 12px 7px;
  background: var(--fg-button, #978cca);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background-color 120ms ease;
}

.agent-create__qfooter-next:hover {
  background: var(--fg-button-hover, #7362c2);
}


/* ─── 빌드 진행 화면 ─── */
.agent-create__pcard {
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 16px;
  padding: 24px 28px 28px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  animation: agent-create-q-fade 0.18s ease-out;
}

.agent-create__pcard--done {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 1px var(--fg-button), 0 6px 18px rgba(0, 0, 0, 0.06);
}

.agent-create__pbar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-bottom: 18px;
}

.agent-create__pbar-seg {
  height: 4px;
  border-radius: 999px;
  background: var(--fg-line);
  transition: background 0.3s ease;
  position: relative;
  overflow: hidden;
}

.agent-create__pbar-seg--done {
  background: var(--fg-button);
}

.agent-create__pbar-seg--active {
  background: var(--fg-line);
}

.agent-create__pbar-seg--active::after {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--fg-button);
  transform-origin: left center;
  animation: agent-create-pbar-grow 4.2s linear forwards;
}

@keyframes agent-create-pbar-grow {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

.agent-create__ptitle {
  margin: 0 0 18px;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* Phase 1 — Workflow Canvas */
.agent-create__pv-canvas {
  position: relative;
  height: 220px;
  background: linear-gradient(180deg, var(--fg-bg-card, #fafafa) 0%, #fff 100%);
  border-radius: 12px;
  overflow: hidden;
}

.agent-create__pv-canvas svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.agent-create__pv-line {
  stroke: var(--fg-button);
  stroke-width: 1.5;
  stroke-dasharray: 4 4;
  opacity: 0;
  animation: agent-create-line-in 0.6s ease-out forwards;
}

.agent-create__pv-particle {
  fill: var(--fg-button);
}

@keyframes agent-create-line-in {
  to {
    opacity: 0.55;
  }
}

.agent-create__pv-node {
  position: absolute;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: var(--fg-text-basic);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  opacity: 0;
  animation: agent-create-node-in 0.4s ease-out forwards;
}

@keyframes agent-create-node-in {
  from {
    opacity: 0;
    transform: scale(0.85);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.agent-create__pv-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 22px;
  background: var(--fg-button);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(86, 60, 240, 0.3);
  opacity: 0;
  animation: agent-create-center-pulse 1.8s ease-out forwards, agent-create-center-glow 2s ease-in-out 1.6s infinite;
}

@keyframes agent-create-center-pulse {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.7);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes agent-create-center-glow {

  0%,
  100% {
    box-shadow: 0 4px 12px rgba(86, 60, 240, 0.3);
  }

  50% {
    box-shadow: 0 4px 20px rgba(86, 60, 240, 0.55);
  }
}

/* Phase 2 — Editor */
.agent-create__pv-editor {
  height: 220px;
  background: #1e1e2e;
  border-radius: 12px;
  padding: 16px 18px;
  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;
  font-size: 12.5px;
  line-height: 22px;
  overflow: hidden;
}

.agent-create__pv-editor-line {
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transform: translateY(4px);
  animation: agent-create-editor-in 0.32s ease-out forwards;
}

@keyframes agent-create-editor-in {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agent-create__pv-editor-num {
  flex-shrink: 0;
  width: 18px;
  text-align: right;
  color: rgba(255, 255, 255, 0.3);
}

.agent-create__pv-editor-text {
  color: #d4d4dc;
}

.agent-create__pv-editor-cursor {
  display: inline-block;
  width: 6px;
  height: 14px;
  margin-left: 4px;
  background: var(--fg-button);
  vertical-align: middle;
  animation: agent-create-blink 0.9s steps(2) infinite;
}

@keyframes agent-create-blink {
  to {
    opacity: 0;
  }
}

.agent-create__hl-keyword {
  color: #c586c0;
}

.agent-create__hl-string {
  color: #ce9178;
}

.agent-create__hl-comment {
  color: #6a9955;
  font-style: italic;
}

/* Phase 3 — Tool Grid */
.agent-create__pv-tools {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.agent-create__pv-tool {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-size: 12px;
  color: var(--fg-text-basic);
  opacity: 0;
  animation: agent-create-tool-in 0.3s ease-out forwards;
}

@keyframes agent-create-tool-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agent-create__pv-tool--matched {
  border-color: var(--fg-button);
  background: var(--fg-bg-card, #faf8ff);
  box-shadow: 0 0 0 1px var(--fg-button) inset;
}

.agent-create__pv-tool--dimmed {
  opacity: 0.4;
}

.agent-create__pv-tool-icon {
  display: grid;
  place-items: center;
  color: var(--fg-text-gray);
}

.agent-create__pv-tool--matched .agent-create__pv-tool-icon {
  color: var(--fg-button);
}

.agent-create__pv-tool-name {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-create__pv-tool-check {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: var(--fg-button);
  border-radius: 50%;
  color: #fff;
}

/* Phase 4 — Meta Checklist */
.agent-create__pv-meta {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agent-create__pv-meta-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  opacity: 0;
  animation: agent-create-meta-in 0.3s ease-out forwards;
  transition: var(--transition-fast);
}

@keyframes agent-create-meta-in {
  from {
    opacity: 0;
    transform: translateX(-4px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.agent-create__pv-meta-row--done {
  border-color: var(--fg-button);
  background: var(--fg-bg-card, #faf8ff);
}

.agent-create__pv-meta-dot {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--fg-line);
  border-radius: 50%;
  color: transparent;
  transition: var(--transition-fast);
}

.agent-create__pv-meta-dot.is-done {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}

.agent-create__pv-meta-label {
  flex: 1 1;
  font-size: 13.5px;
  color: var(--fg-text-basic);
}

.agent-create__pv-meta--complete .agent-create__pv-meta-row {
  border-color: var(--fg-button);
}

.agent-create__preset {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  padding: 12px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-create__preset:hover {
  border-color: var(--fg-button);
}

.agent-create__preset-body {
  flex: 1 1;
  min-width: 0;
}

.agent-create__preset-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.agent-create__preset-sub {
  margin: 2px 0 0;
  font-size: 14px;
  color: var(--fg-text-gray);
}


/* ========================================================================
   AgentIntegrations — 외부 서비스 연결 (Figma 76:7677)
   ======================================================================== */

.agent-int__group {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.agent-int__group-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.agent-int__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

@media (max-width: 1280px) {
  .agent-int__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* 카드 (시안과 동일 — 작은 가로형) */
.agent-int__card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  height: 74px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-int__card:hover {
  border-color: var(--fg-button);
}

.agent-int__card--on {
  background: var(--fg-bg-connected);
}

.agent-int__logo {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.agent-int__body {
  flex: 1 1;
  min-width: 0;
}

.agent-int__name {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.agent-int__desc {
  margin: 2px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-text-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Connect 버튼 — 시안의 ButtonConnect (32px 라운드, on 상태 라임그린) */
.agent-int__connect {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: var(--fg-bg-card);
  border: 0;
  border-radius: 16px;
  color: var(--fg-text-gray);
  cursor: pointer;
  padding: 4px;
  transition: var(--transition-fast);
}

.agent-int__connect:hover {
  background: #ececec;
}

.agent-int__connect--on {
  background: var(--fg-bg-connect-on);
  color: var(--fg-text-basic);
}

.agent-int__connect--on:hover {
  background: #95dd45;
}

/* ========================================================================
   AgentSkills — 스킬 카탈로그 (Figma 76:7854)
   ======================================================================== */

.agent-skills__filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.agent-skills__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 1280px) {
  .agent-skills__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.agent-skills__card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.agent-skills__card:hover {
  border-color: var(--fg-button);
}

.agent-skills__card--selected {
  background: var(--fg-bg-step-active);
  border-color: var(--fg-side-hover);
}

.agent-skills__body {
  flex: 1 1;
  min-width: 0;
  padding-top: 1px;
}

.agent-skills__name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-skills__desc {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--fg-text-gray);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.agent-skills__actions {
  flex-shrink: 0;
  display: flex;
  gap: 0;
}

/* ========================================================================
   AgentEdit — 편집 화면 (Figma 76:11823 workflow + 78:4980 folder 통합)
   ======================================================================== */

.agent-edit__main {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.agent-edit__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 8px 16px;
  background: var(--fg-bg-toolbar);
  border-radius: 16px 16px 0 0;
  gap: 8px;
  flex-shrink: 0;
}

.agent-edit__toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.agent-edit__toolbar-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.agent-edit__toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

/* 툴바 버튼 그룹 (segmented) — 1px 간격으로 붙여 표시 */
.agent-edit__tb-group {
  display: inline-flex;
  align-items: center;
  gap: 1px;
}

.agent-edit__tb-group>.agent-edit__tb-btn {
  border-radius: 0;
}

.agent-edit__tb-group>.agent-edit__tb-btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.agent-edit__tb-group>.agent-edit__tb-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* 툴바 버튼 base */
.agent-edit__tb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp);
  border: 0;
  border-radius: 4px;
  color: var(--fg-button-hover);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__tb-btn:hover {
  background: #dde0ee;
}

.agent-edit__tb-btn--active,
.agent-edit__tb-btn--primary {
  background: var(--fg-button);
  color: #fff;
}

.agent-edit__tb-btn--active:hover,
.agent-edit__tb-btn--primary:hover {
  background: var(--fg-button-hover);
}

.agent-edit__tb-btn--icononly {
  padding: 5px 7px 7px;
}

.agent-edit__tb-back {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  padding: 0;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.agent-edit__tb-back:hover {
  color: var(--fg-text-purple);
}

/* 본문: 좌 채팅 + 우 view */
.agent-edit__body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

/* 좌측 채팅 패널 */
.agent-edit__chat {
  flex: 1 1;
  min-width: 0;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-right: 1px solid var(--fg-line);
}

.agent-edit__chat-toolbar {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
}

.agent-edit__chat-mode-chip {
  padding: 6px 12px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 16px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__chat-mode-chip--active {
  background: var(--fg-bg-mychat);
  border-color: var(--fg-button-hover);
  color: var(--fg-button-hover);
  font-weight: 600;
}

.agent-edit__chat-scroller {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.agent-edit__chat-time {
  align-self: flex-start;
}

.agent-edit__chat-banner {
  margin: 0 16px 4px;
  padding: 6px 10px;
  background: #ffe6df;
  color: var(--fg-anti-red);
  border-radius: 6px;
  text-align: center;
  font-size: 12px;
}

.agent-edit__chat-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px 16px;
  background: #fff;
  border-top: 1px solid var(--fg-line);
  flex-shrink: 0;
}

.agent-edit__chat-input-field {
  flex: 1 1;
  min-width: 0;
  padding: 10px 16px;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
  font-family: inherit;
  font-size: 14px;
  outline: none;
  background: #fff;
  color: var(--fg-text-basic);
}

.agent-edit__chat-input-field:disabled {
  background: var(--fg-bg-card);
  cursor: not-allowed;
}

.agent-edit__chat-send {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--fg-button);
  padding: 0;
}

.agent-edit__chat-send:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 우측 캔버스 (workflow) */
.agent-edit__canvas {
  flex: 1 1;
  min-width: 0;
  position: relative;
  background: #fafafa;
  overflow: auto;
}

.agent-edit__canvas-zoom {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: var(--fg-text-basic);
  color: #fff;
  border-radius: 30px;
  z-index: 5;
}

.agent-edit__canvas-zoom button {
  background: transparent;
  border: 0;
  color: #fff;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.agent-edit__canvas-zoom button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.agent-edit__canvas-zoom span {
  font-size: 12px;
}

/* Workflow 노드 그리드 */
.agent-edit__workflow {
  padding: 80px 18px 30px;
  display: flex;
  justify-content: center;
}

/* Figma 캔버스(Group 1, 772×372) — 절대 좌표 + 연결선 */
.agent-edit__canvas {
  position: relative;
  width: 772px;
  height: 372px;
  flex-shrink: 0;
}

/* Origin ↔ 위성 노드 연결선 */
.agent-edit__line {
  position: absolute;
  height: 2px;
  background: #86b6f3;
  pointer-events: none;
}

.agent-edit__node {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--fg-blue-lite, #86b6f3);
  border-radius: 12px;
  overflow: hidden;
  font-size: 12px;
}

.agent-edit__node--highlight {
  border: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.13);
}

.agent-edit__node-head {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 12px;
  background: var(--fg-bg-card);
}

.agent-edit__node--highlight .agent-edit__node-head {
  padding: 4px 8px 8px 12px;
  background: var(--fg-button);
}

.agent-edit__node-eyebrow {
  flex: 1 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray);
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-edit__node--highlight .agent-edit__node-eyebrow {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.agent-edit__node-action {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}

.agent-edit__node-action:hover {
  background: rgba(255, 255, 255, 0.2);
}

.agent-edit__node--normal .agent-edit__node-action:hover {
  background: rgba(0, 0, 0, 0.05);
}

.agent-edit__node-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
}

.agent-edit__node--highlight .agent-edit__node-body {
  gap: 12px;
  padding: 12px;
}

.agent-edit__node--highlight .agent-edit__node-section+.agent-edit__node-section {
  border-top: 1px solid var(--fg-line);
  padding-top: 12px;
}

.agent-edit__node-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.agent-edit__node-li {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px 2px 8px;
  background: #fff;
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-text-basic);
}

.agent-edit__node-li-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--fg-text-basic);
}

.agent-edit__node-li-name {
  flex-shrink: 0;
  color: var(--fg-text-basic);
}

.agent-edit__node-li-sub {
  flex-shrink: 0;
  color: #bdbdbd;
}

.agent-edit__node-li-remove {
  flex-shrink: 0;
  margin-left: auto;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.agent-edit__node-li-remove:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-text-basic);
}

.agent-edit__node-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: var(--fg-text-gray);
}

.agent-edit__node-dot--green {
  background: var(--fg-text-publishing);
}

.agent-edit__node-dot--gray {
  background: #c2c2c2;
}

.agent-edit__node-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-edit__node-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.agent-edit__node-label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  color: var(--fg-text-gray);
}

.agent-edit__node-text {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-basic);
}

.agent-edit__node-box {
  height: 68px;
  padding: 8px;
  background: #f8f8f8;
  border-radius: 8px;
  font-size: 12px;
  color: var(--fg-text-gray);
  overflow-y: auto;
  overflow-x: hidden;
}

.agent-edit__node-text-legacy {
  margin: 0;
  padding: 4px 6px;
  background: var(--fg-bg-card);
  border-radius: 4px;
  font-size: 11px;
  color: var(--fg-text-basic);
  font-family: ui-monospace, 'SF Mono', Consolas, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Folder view */
.agent-edit__folder {
  flex: 1 1;
  min-width: 0;
  display: flex;
  background: #fafafa;
}

.agent-edit__folder-tree {
  width: 200px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 16px 12px;
  background: #fff;
  border-right: 1px solid var(--fg-line);
}

.agent-edit__folder-item {
  padding: 8px 10px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__folder-item:hover {
  background: var(--fg-bg-card);
}

.agent-edit__folder-item--active {
  background: var(--fg-bg-mychat);
  color: var(--fg-button-hover);
  font-weight: 600;
}

.agent-edit__folder-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.agent-edit__folder-content-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid var(--fg-line);
}

.agent-edit__folder-tabs {
  display: flex;
  gap: 4px;
}

.agent-edit__folder-tab {
  padding: 6px 12px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 16px;
  font-family: inherit;
  font-size: 12px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.agent-edit__folder-tab--active {
  background: var(--fg-bg-mychat);
  border-color: var(--fg-button-hover);
  color: var(--fg-button-hover);
  font-weight: 600;
}

.agent-edit__folder-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 32px;
}

.agent-edit__folder-empty {
  text-align: center;
  color: var(--fg-text-gray);
  padding: 40px;
}

@media (max-width: 1280px) {
  .agent-edit__chat {
    max-width: 480px;
  }
}

/* ========================================================================
   AgentChat — 에이전트 대화 + Workflow/Folder 패널 토글
   ======================================================================== */

.agent-chat__main {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 52px);
  overflow: hidden;
}

.agent-chat__body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
  background: #fff;
}

.agent-chat__main-area {
  position: relative;
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* 채팅 스크롤 */
.agent-chat__scroller {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px 24px 16px;
}

.agent-chat__messages {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.agent-chat__empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-chat__empty-text {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--fg-text-gray);
  text-align: center;
}

/* 점 3개 펄스 (AgentCreate 입력 분석 상태 표시 등에서 사용) */
.agent-chat__loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.agent-chat__loading-dots span {
  width: 5px;
  height: 5px;
  background: var(--fg-text-gray);
  border-radius: 50%;
  opacity: 0.4;
  animation: agent-chat-dot 1.2s infinite ease-in-out;
}

.agent-chat__loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.agent-chat__loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes agent-chat-dot {

  0%,
  80%,
  100% {
    opacity: 0.25;
    transform: translateY(0);
  }

  40% {
    opacity: 1;
    transform: translateY(-2px);
  }
}

.agent-chat__body--with-panel .agent-chat__messages {
  max-width: none;
}

/* 입력 */
.agent-chat__input-area {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 16px 24px 20px;
  background: #fff;
  border-top: 1px solid var(--fg-line);
}

.agent-chat__input {
  flex: 1 1;
  min-width: 0;
  padding: 12px 20px;
  border: 1px solid var(--fg-line);
  border-radius: 22px;
  font-family: inherit;
  font-size: 15px;
  line-height: 22px;
  outline: none;
  background: #fff;
  color: var(--fg-text-basic);
  resize: none;
  overflow-y: hidden;
  max-height: 160px;
  box-sizing: border-box;
}

.agent-chat__input:focus {
  border-color: var(--fg-button);
}

.agent-chat__send {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--fg-button);
  padding: 0;
}

.agent-chat__send:hover {
  color: var(--fg-button-hover);
}

/* ────────── 어시스턴트 인라인 카드 (clarify / modify_approval / oauth / tool-approval) ────────── */
.agent-chat__assistant-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agent-chat__card {
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 14px;
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.04));
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
}

.agent-chat__card--answered {
  opacity: 0.7;
  background: var(--fg-bg-card, #f5f5f7);
}

.agent-chat__card-eyebrow {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--fg-text-gray);
}

/* ── Clarify (G-check 선택지) ── */
.agent-chat__card-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agent-chat__card-option-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast, 0.15s ease);
}

.agent-chat__card-option-btn:hover:not(:disabled) {
  background: var(--fg-bg-liteblue);
  border-color: var(--fg-button-hover);
}

.agent-chat__card-option-btn:disabled {
  cursor: not-allowed;
  background: var(--fg-bg-card, #f5f5f7);
}

.agent-chat__card-option-key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--fg-bg-liteblue);
  color: var(--fg-button);
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.agent-chat__card-option-label {
  flex: 1 1;
}

/* ── Action list (modify / tool approval 공용) ── */
.agent-chat__card-action-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agent-chat__card-action {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: var(--fg-bg-card, #f5f5f7);
  border-radius: 8px;
  font-size: 13px;
  color: var(--fg-text-basic);
}

.agent-chat__card-action-tag {
  flex-shrink: 0;
  padding: 2px 8px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-chat__card-action-tag--done {
  background: #e8f7ee;
  border-color: #b9e2c8;
  color: #1a7d3c;
}

.agent-chat__card-action-text {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-chat__card-action-list--applied {
  margin-bottom: 2px;
}

/* ── Action buttons (승인/거절/연결) ── */
.agent-chat__card-actions {
  display: flex;
  gap: 8px;
}

.agent-chat__card-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  background: #fff;
  color: var(--fg-text-basic);
  transition: var(--transition-fast, 0.15s ease);
}

.agent-chat__card-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.agent-chat__card-btn--primary {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}

.agent-chat__card-btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
}

.agent-chat__card-btn--ghost:hover:not(:disabled) {
  background: var(--fg-bg-card, #f5f5f7);
}

/* ── OAuth 카드 ── */
.agent-chat__card-oauth-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agent-chat__card-oauth-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--fg-line);
  padding: 4px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.agent-chat__card-oauth-icon--fallback {
  color: var(--fg-text-gray);
}

.agent-chat__card-oauth-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.agent-chat__card-oauth-name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-chat__card-oauth-desc {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
  white-space: pre-wrap;
  word-break: break-word;
}

.agent-chat__card-oauth-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.agent-chat__card-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: var(--fg-bg-liteblue);
  color: var(--fg-button);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: lowercase;
}

/* ── Note 카드 (notion picker / 미지원 / fallback paused) ── */
.agent-chat__card--note {
  background: var(--fg-bg-warm, #fff8ec);
  border-color: var(--warning-border, #f0d089);
}

.agent-chat__card-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
  word-break: break-word;
}

.agent-chat__card-note {
  margin: 0;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px dashed var(--warning-border, #f0d089);
  border-radius: 8px;
  font-size: 12px;
  color: var(--fg-text-gray);
  line-height: 1.5;
}

/* ── 노션 페이지 picker 카드 modifier (안내 카드와 톤 분리) ── */
.agent-chat__card--picker {
  background: #fff;
  border-color: var(--fg-line);
}

/* ═══════════════════════════════════════════════════════════════════════════
   노션 페이지 picker 모달 (paused / notion_page_picker)
   skill-modal__* 패턴과 동일한 디자인 토큰(--fg-*) 체계로 재작성.
   ═══════════════════════════════════════════════════════════════════════════ */
.agent-notion-picker__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 24px;
  animation: agentNotionPickerFade 0.18s ease-out;
}

@keyframes agentNotionPickerFade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.agent-notion-picker {
  width: 100%;
  max-width: 520px;
  /* 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */
  height: calc(100vh - 120px);
  max-height: calc(100vh - 120px);
  min-height: 480px;
  background: #fff;
  color: var(--fg-text-basic, #111827);
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 14px;
  animation: agentNotionPickerPop 160ms ease-out;
}

@keyframes agentNotionPickerPop {
  from {
    transform: translateY(8px) scale(0.98);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.agent-notion-picker__bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid var(--fg-line, #e5e7eb);
}

.agent-notion-picker__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic, #111827);
}

.agent-notion-picker__logo {
  width: 22px;
  height: 22px;
  background: var(--fg-text-basic, #111827);
  color: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.5px;
}

.agent-notion-picker__title-block {
  padding: 20px 24px 12px;
}

.agent-notion-picker__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic, #111827);
  letter-spacing: -0.2px;
  line-height: 1.4;
}

.agent-notion-picker__search-block {
  padding: 0 24px 12px;
}

.agent-notion-picker__search {
  position: relative;
}

.agent-notion-picker__search svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  color: var(--fg-text-gray, #6b7280);
}

.agent-notion-picker__search input {
  width: 100%;
  padding: 10px 12px 10px 34px;
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  color: var(--fg-text-basic, #111827);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.agent-notion-picker__search input:focus {
  border-color: var(--fg-button, #978cca);
  box-shadow: var(--focus-ring, 0 0 0 2px var(--primary-200, #ddd6fe));
}

.agent-notion-picker__search input::placeholder {
  color: var(--fg-text-gray, #6b7280);
}

.agent-notion-picker__banner {
  margin: 0 24px 10px;
  padding: 9px 12px;
  background: var(--fg-bg-warning, #fff7ed);
  color: var(--warning-text, #92400e);
  border: 1px solid var(--warning-border, #fcd34d);
  border-radius: 8px;
  font-size: 13px;
}

.agent-notion-picker__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 16px 12px;
  min-height: 0;
}

.agent-notion-picker__body::-webkit-scrollbar {
  width: 6px;
}

.agent-notion-picker__body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 3px;
}

.agent-notion-picker__body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.32);
}

.agent-notion-picker__body::-webkit-scrollbar-track {
  background: transparent;
}

.agent-notion-picker__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.agent-notion-picker__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin: 2px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.12s;
  color: var(--fg-text-basic, #111827);
}

.agent-notion-picker__item:hover {
  background: var(--fg-bg-litepp, #e8eaf5);
}

.agent-notion-picker__item--selected {
  background: var(--fg-bg-step-active, #f3f4ff);
  color: var(--fg-text-purple, #7362c2);
}

.agent-notion-picker__item-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: var(--fg-text-gray, #6b7280);
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-notion-picker__item--selected .agent-notion-picker__item-icon {
  color: var(--fg-text-purple, #7362c2);
}

.agent-notion-picker__item-icon svg {
  width: 16px;
  height: 16px;
  display: block;
}

.agent-notion-picker__item-title {
  flex: 1 1;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-notion-picker__item--selected .agent-notion-picker__item-title {
  font-weight: 600;
}

.agent-notion-picker__item-check {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: var(--fg-text-purple, #7362c2);
}

.agent-notion-picker__state {
  padding: 44px 24px 36px;
  text-align: center;
}

.agent-notion-picker__state-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic, #111827);
  margin-bottom: 8px;
}

.agent-notion-picker__state-desc {
  font-size: 13px;
  color: var(--fg-text-gray, #6b7280);
  margin-bottom: 22px;
  line-height: 1.6;
}

.agent-notion-picker__state-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  background: var(--fg-button, #978cca);
  color: #fff;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s;
}

.agent-notion-picker__state-btn:hover {
  background: var(--fg-button-hover, #7362c2);
}

.agent-notion-picker__skel-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}

.agent-notion-picker__skel {
  background: linear-gradient(90deg,
      var(--fg-bg-content, #f2f2f2),
      var(--fg-line, #e5e7eb),
      var(--fg-bg-content, #f2f2f2));
  background-size: 200% 100%;
  animation: agentNotionPickerShimmer 1.6s infinite linear;
  border-radius: 4px;
}

@keyframes agentNotionPickerShimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.agent-notion-picker__skel--icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.agent-notion-picker__skel--line {
  height: 11px;
  width: 55%;
}

.agent-notion-picker__footer {
  padding: 12px 24px 16px;
  border-top: 1px solid var(--fg-line, #e5e7eb);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.agent-notion-picker__btn {
  height: 36px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.agent-notion-picker__btn--cancel {
  background: transparent;
  color: var(--fg-text-basic, #111827);
  border-color: var(--fg-line, #e5e7eb);
}

.agent-notion-picker__btn--cancel:hover {
  background: rgba(15, 23, 42, 0.04);
}

.agent-notion-picker__btn--primary {
  background: var(--fg-button, #978cca);
  color: #fff;
}

.agent-notion-picker__btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover, #7362c2);
}

.agent-notion-picker__btn--primary:disabled {
  background: var(--fg-line, #e5e7eb);
  color: var(--fg-text-gray, #6b7280);
  cursor: not-allowed;
}

/* 패널 열린 상태 — Figma 비율 (chat 728 : panel 808 ≈ 47:53) */
.agent-chat__body--with-panel .agent-chat__main-area {
  flex: 728 0;
  min-width: 380px;
  border-right: 1px solid var(--fg-line);
}

.agent-chat__body--with-panel .agent-chat__messages {
  max-width: 100%;
}

/* 우측 슬라이드 패널 */
.agent-chat__panel {
  position: relative;
  flex: 808 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.04);
  animation: agentChatPanelIn 0.18s ease-out;
}

@keyframes agentChatPanelIn {
  from {
    transform: translateX(20px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.agent-chat__panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--fg-bg-toolbar);
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
}

.agent-chat__panel-head--folder {
  background: #fff;
}

.agent-chat__panel-zoom {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: var(--fg-text-basic);
  color: #fff;
  border-radius: 30px;
}

.agent-chat__panel-zoom button {
  background: transparent;
  border: 0;
  color: #fff;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.agent-chat__panel-zoom button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.agent-chat__panel-zoom span {
  font-size: 12px;
}

.agent-chat__panel-close {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.agent-chat__panel-close:hover {
  background: rgba(0, 0, 0, 0.05);
}

.agent-chat__panel-body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
}

.agent-chat__panel-body--folder {
  display: flex;
  overflow: hidden;
  background: #fff;
}

.agent-chat__panel-body--folder .agent-edit__folder-tree {
  width: 140px;
  flex-shrink: 0;
  border-right: 1px solid var(--fg-line);
  background: #fff;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agent-chat__panel-body--folder .agent-edit__folder-tree .agent-edit__folder-item {
  font-size: 13px;
  padding: 6px 8px;
}

.agent-chat__panel-body--folder .agent-edit__folder-body {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
  padding: 20px 28px;
  background: #fff;
}

/* 파일 트리 아이템 — 아이콘 + 이름 가로 정렬 */
.agent-edit__folder-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--fg-text-basic);
}

.agent-edit__folder-item svg {
  flex-shrink: 0;
  color: var(--fg-text-gray);
}

.agent-edit__folder-item--active svg {
  color: var(--fg-button-hover);
}

/* 우측 콘텐츠 래퍼 (헤더 + 본문) */
.agent-chat__panel-body--folder .agent-edit__folder-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.agent-chat__panel-body--folder .agent-edit__folder-content-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--fg-line);
  background: var(--fg-bg-card, #fafafa);
}

.agent-edit__folder-content-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-edit__folder-content-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 파일명 (헤더 좌측) */
.agent-edit__folder-filename {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* 우측 헤더 액션: Read-only 뱃지 / 저장 */
.agent-edit__folder-badge {
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-text-gray);
  padding: 4px 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.agent-edit__folder-save {
  background: var(--fg-button);
  border: 1px solid var(--fg-button);
  color: #fff;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__folder-save:hover:not(:disabled) {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
}

.agent-edit__folder-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* AGENTS.md Source 모드 — 마크다운 툴바 + 텍스트에어리어 */
.agent-edit__folder-source {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: -20px -28px;
}

.agent-edit__folder-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 16px;
  background: var(--fg-bg-card, #fafafa);
  border-bottom: 1px solid var(--fg-line);
}

.agent-edit__folder-toolbar button {
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  padding: 4px 10px;
  font-family: inherit;
  font-size: 12px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__folder-toolbar button:hover {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.agent-edit__folder-toolbar-sep {
  width: 1px;
  height: 18px;
  background: var(--fg-line);
  margin: 0 4px;
}

.agent-edit__folder-editor {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  resize: none;
  padding: 16px 20px;
  background: #fff;
  border: 0;
  outline: none;
  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;
  font-size: 13px;
  line-height: 22px;
  color: var(--fg-text-basic);
}

.agent-edit__folder-editor--full {
  height: 100%;
  margin: -20px -28px;
  padding: 16px 24px;
}

/* config.json 코드 블록 */
.agent-edit__folder-code {
  margin: 0;
  padding: 16px 20px;
  background: var(--fg-bg-card, #fafafa);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;
  font-size: 12.5px;
  line-height: 20px;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
}

/* =====================================================
   Workflow 패널 — 캔버스 (Figma 2065:14802)
   - 패널 전체가 다크 캔버스. 노드는 절대 좌표 배치.
   - 점선 연결: origin ↔ 위성 노드
   ===================================================== */
.agent-chat__panel--workflow {
  background: var(--fg-bg-dark);
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.2);
}

.workflow-canvas {
  position: relative;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  /* background: var(--fg-bg-dark); */
  background: #fbfbfb;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.workflow-canvas--panning,
.workflow-canvas--panning .workflow-canvas__inner {
  cursor: grabbing;
}

/* 줌/맞춤/닫기 컨트롤 — 호버 시 표시 (Figma 2065:14785) */
.workflow-canvas__toolbar {
  position: absolute;
  top: 16px;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.18s ease;
}

.workflow-canvas:hover .workflow-canvas__toolbar,
.workflow-canvas:focus-within .workflow-canvas__toolbar {
  opacity: 1;
}

.workflow-canvas__toolbar-pill {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 6px;
  background: var(--fg-text-basic);
  border-radius: 30px;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.29));
}

.workflow-canvas__toolbar-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.workflow-canvas__toolbar-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.workflow-canvas__toolbar-text {
  padding: 0 2px;
  font-size: 12px;
  color: #fff;
  -webkit-user-select: none;
          user-select: none;
}

.workflow-canvas__inner {
  position: absolute;
  left: 0;
  top: 0;
  width: 800px;
  height: 520px;
  margin: 0;
  transform-origin: 0 0;
  will-change: transform;
}

/* 점선 연결선 (SVG bezier) — origin ↔ 위성 박스 */
.workflow-canvas__svg {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  overflow: visible;
  z-index: 0;
}

.workflow-canvas__svg-path {
  fill: none;
  stroke: var(--fg-blue-lite);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-dasharray: 6 5;
}

/* legacy span 점선 — 신규 SVG 로 교체됐지만 다른 곳에서 쓸 수 있어 유지 */
.workflow-canvas__line {
  position: absolute;
  height: 0;
  border-top: 2px dashed var(--fg-blue-lite);
  pointer-events: none;
}

/* 노드 박스 헤더 — 드래그 핸들 */
.workflow-node__header--draggable {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.workflow-node__header--draggable:active {
  cursor: grabbing;
}

/* ── 공통 노드 ── */
.workflow-node {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  font-family: var(--font-sans);
}

.workflow-node__icon-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.workflow-node__icon-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.workflow-node__icon-btn--on-purple {
  color: #fff;
}

.workflow-node__icon-btn--on-purple:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* ── origin 노드 (메인 에이전트) ── */
.workflow-node--origin {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.13);
  z-index: 2;
}

.workflow-node__header--origin {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px 14px 18px;
  background: var(--fg-button);
}

.workflow-node__title {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-node__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
}

.workflow-node__section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workflow-node__section+.workflow-node__section {
  padding-top: 12px;
  border-top: 1px solid var(--fg-line);
}

.workflow-node__label {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.15;
  color: var(--fg-text-gray);
  letter-spacing: 0.02em;
}

.workflow-node__text {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--fg-text-basic);
  word-break: break-word;
}

.workflow-node__box {
  height: 400px;
  padding: 14px;
  background: var(--fg-bg-content);
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--fg-text-gray);
  overflow-x: hidden;
  overflow-y: auto;
  word-break: break-word;
}

/* ── side 노드 (FEW-SHOT EXAMPLES) ── */
.workflow-node--side {
  border: 1px solid var(--fg-blue-lite);
  min-height: 160px;
  max-height: 210px;
}

.workflow-node__empty {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 14px;
  min-height: 110px;
}

.workflow-node__empty-text {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
  text-align: center;
}

.workflow-node__header--side {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px 8px 16px;
  background: var(--fg-bg-card);
}

.workflow-node__header--side .workflow-node__icon-btn {
  width: 26px;
  height: 26px;
}

.workflow-node__eyebrow {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.15;
  color: var(--fg-text-gray);
  letter-spacing: 0.02em;
}

.workflow-node__list {
  list-style: none;
  margin: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.workflow-node__list::-webkit-scrollbar {
  width: 6px;
}

.workflow-node__list::-webkit-scrollbar-thumb {
  background: var(--fg-line);
  border-radius: 3px;
}

.workflow-node__list::-webkit-scrollbar-thumb:hover {
  background: var(--fg-text-menu);
}

.workflow-node__list-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 6px 6px 10px;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
  flex-shrink: 0;
}

.workflow-node__list-item:hover {
  background: var(--fg-bg-card);
}

.workflow-node__dot {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--fg-line);
}

.workflow-node__dot--green {
  background: var(--fg-class-green);
}

.workflow-node__list-icon {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  color: var(--fg-text-basic);
}

.workflow-node__list-favicon {
  display: block;
  border-radius: 4px;
}

.workflow-node__list-text {
  flex: 1 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workflow-node__list-name {
  color: var(--fg-text-basic);
}

.workflow-node__list-sub {
  color: var(--fg-text-menu);
}

.workflow-node__list-remove {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.workflow-node__list-remove:hover {
  color: var(--fg-anti-red);
  background: rgba(0, 0, 0, 0.04);
}

/* ── 연결 provider 묶음(connected_tool_packs) ── */
.workflow-node__pack {
  display: flex;
  flex-direction: column;
}

.workflow-node__pack-head {
  width: 100%;
}

.workflow-node__pack-caret {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  color: var(--fg-text-menu);
  transition: transform var(--transition-fast), color var(--transition-fast);
}

.workflow-node__pack-head:hover .workflow-node__pack-caret {
  color: var(--fg-text-basic);
}

.workflow-node__pack-caret.is-open {
  transform: rotate(90deg);
}

/* 묶음 개수 배지 — 다크 네이비 pill */
.workflow-node__count-badge {
  flex-shrink: 0;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  display: inline-grid;
  place-items: center;
  background: var(--fg-bg-dark);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  border-radius: 9px;
}

/* 펼친 멤버 도구 — 들여쓰기 + 약하게 */
.workflow-node__pack-members {
  list-style: none;
  margin: 2px 0 2px 14px;
  padding: 0 0 0 8px;
  border-left: 1px solid var(--fg-line);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workflow-node__pack-member {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 6px;
}

.workflow-node__pack-member .workflow-node__list-icon {
  color: var(--fg-text-menu);
}

.workflow-node__pack-member .workflow-node__list-text {
  font-size: 12px;
}

.workflow-node__pack-member .workflow-node__list-name {
  color: var(--fg-text-gray);
}


/* =====================================================
   스킬 상세 모달 (SkillDetailModal)
   ===================================================== */
.skill-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: skill-modal-fade-in 120ms ease-out;
}

@keyframes skill-modal-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.skill-modal__dialog {
  width: 100%;
  max-width: 640px;
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  animation: skill-modal-pop-in 160ms ease-out;
}

@keyframes skill-modal-pop-in {
  from {
    transform: translateY(8px) scale(0.98);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* head */
.skill-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--fg-line, #e5e7eb);
}

.skill-modal__head-text {
  min-width: 0;
}

.skill-modal__eyebrow {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--fg-text-gray, #6b7280);
  text-transform: uppercase;
}

.skill-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic, #111827);
  word-break: break-word;
}

.skill-modal__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray, #6b7280);
  cursor: pointer;
  transition: var(--transition-fast, background-color 120ms);
}

.skill-modal__close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: var(--fg-text-basic, #111827);
}

/* body */
.skill-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.skill-modal__body::-webkit-scrollbar {
  width: 6px;
}

.skill-modal__body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 3px;
}

.skill-modal__body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.32);
}

.skill-modal__body::-webkit-scrollbar-track {
  background: transparent;
}

.skill-modal__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skill-modal__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray, #6b7280);
  letter-spacing: 0.02em;
}

.skill-modal__text {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic, #111827);
  white-space: pre-wrap;
}

.skill-modal__value {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #111827);
}

.skill-modal__meta-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;
}

.skill-modal__meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.skill-modal__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.skill-modal__chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  background: var(--fg-bg-mychat, #f3f4f6);
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 999px;
  font-size: 12px;
  color: var(--fg-text-basic, #111827);
}

.skill-modal__markdown {
  padding: 12px 14px;
  background: var(--fg-bg-mychat, #f9fafb);
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 10px;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic, #111827);
  max-height: 320px;
  overflow-y: auto;
}

.skill-modal__markdown p {
  margin: 0 0 8px;
}

.skill-modal__markdown p:last-child {
  margin-bottom: 0;
}

.skill-modal__markdown h1,
.skill-modal__markdown h2,
.skill-modal__markdown h3 {
  margin: 12px 0 6px;
  font-weight: 600;
}

.skill-modal__markdown ul,
.skill-modal__markdown ol {
  padding-left: 20px;
  margin: 0 0 8px;
}

.skill-modal__markdown code {
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-size: 13px;
}

.skill-modal__markdown pre {
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  overflow-x: auto;
}

.skill-modal__markdown pre code {
  padding: 0;
  background: transparent;
}

.skill-modal__timestamps {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px 16px;
  font-size: 12px;
  color: var(--fg-text-gray, #6b7280);
}

.skill-modal__timestamp {
  white-space: nowrap;
}

.skill-modal__empty {
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: var(--fg-text-gray, #6b7280);
  padding: 24px 0;
}

/* foot */
.skill-modal__foot {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px 16px;
  border-top: 1px solid var(--fg-line, #e5e7eb);
}

.skill-modal__foot-spacer {
  flex: 1 1;
}

.skill-modal__btn {
  height: 36px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition-fast, all 120ms);
  border: 1px solid transparent;
}

.skill-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.skill-modal__btn--primary {
  background: var(--fg-button, #7c3aed);
  color: #fff;
}

.skill-modal__btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover, #6d28d9);
}

.skill-modal__btn--ghost {
  background: transparent;
  color: var(--fg-text-basic, #111827);
  border-color: var(--fg-line, #e5e7eb);
}

.skill-modal__btn--ghost:hover:not(:disabled) {
  background: rgba(15, 23, 42, 0.04);
}

.skill-modal__btn--danger {
  background: transparent;
  color: var(--fg-anti-red, #dc2626);
  border-color: rgba(220, 38, 38, 0.32);
}

.skill-modal__btn--danger:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.08);
}


/* 모드 탭 (생성 모달의 AI/직접 토글) */
.skill-modal__tabs {
  display: inline-flex;
  background: var(--fg-bg-litepp, #f3f4f6);
  padding: 4px;
  border-radius: 10px;
  gap: 4px;
}

.skill-modal__tab {
  padding: 6px 14px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray, #6b7280);
  cursor: pointer;
  transition: var(--transition-fast);
}

.skill-modal__tab--active {
  background: #fff;
  color: var(--fg-button, #7c3aed);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.skill-modal__tab:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* skill.md 라벨 + AI 보조 액션 행 */
.skill-modal__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.skill-modal__ai-actions {
  display: inline-flex;
  gap: 6px;
}

.skill-modal__ai-btn {
  height: 28px;
  padding: 0 10px;
  background: var(--fg-bg-litepp, #f3f4f6);
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-button-hover, #6d28d9);
  cursor: pointer;
  transition: var(--transition-fast);
}

.skill-modal__ai-btn:hover:not(:disabled) {
  background: #fff;
  border-color: var(--fg-button, #7c3aed);
  color: var(--fg-button, #7c3aed);
}

.skill-modal__ai-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 생성 모달 미리보기 토글 */
.skill-modal__preview-toggle {
  margin-top: 8px;
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 8px;
  padding: 8px 12px;
}

.skill-modal__preview-toggle>summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic, #111827);
  -webkit-user-select: none;
          user-select: none;
}

.skill-modal__preview-toggle .skill-modal__markdown {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--fg-line, #e5e7eb);
}

/* 편집 모드 폼 컨트롤 */
.skill-modal__input,
.skill-modal__textarea {
  width: 100%;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic, #111827);
  font-family: inherit;
  transition: var(--transition-fast, border-color 120ms);
  box-sizing: border-box;
}

.skill-modal__textarea {
  resize: vertical;
  min-height: 64px;
}

.skill-modal__textarea--code {
  font-family: 'JetBrains Mono', 'Consolas', 'Menlo', monospace;
  font-size: 13px;
  line-height: 20px;
  min-height: 200px;
}

.skill-modal__input:focus,
.skill-modal__textarea:focus {
  outline: none;
  border-color: var(--fg-button, #7c3aed);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
}

.skill-modal__hint {
  font-size: 11px;
  font-weight: 400;
  color: var(--fg-text-gray, #9ca3af);
  margin-left: 4px;
}

.skill-modal__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #111827);
  cursor: pointer;
}

.skill-modal__toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* =====================================================
   스킬 생성 모달 (SkillCreateModal) — 피그마 2026-04 시안
   ===================================================== */
.skill-modal__dialog--create {
  max-width: 743px;
  border-radius: 16px;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);
}

.skill-modal__dialog--create .skill-modal__head {
  align-items: center;
  gap: 4px;
  padding: 20px 20px 12px;
  border-bottom: 1px solid var(--fg-line, #dbdbdb);
}

.skill-modal__dialog--create .skill-modal__title {
  flex: 1 0;
  min-width: 0;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic, #3b3b3b);
}

.skill-modal__dialog--create .skill-modal__close {
  width: 32px;
  height: 32px;
  padding: 2px;
  border-radius: 8px;
}

.skill-modal__dialog--create .skill-modal__body {
  padding: 20px;
  gap: 20px;
}

.skill-modal__dialog--create .skill-modal__section {
  gap: 8px;
}

.skill-modal__lead {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: var(--fg-text-basic, #3b3b3b);
}

/* 탭 (언더라인) */
.skill-modal__dialog--create .skill-modal__tabs {
  display: flex;
  width: 100%;
  padding: 0;
  gap: 4px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 0;
}

.skill-modal__dialog--create .skill-modal__tab {
  flex: 1 0;
  min-width: 0;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  box-shadow: none;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  transition: color 120ms ease, border-color 120ms ease;
}

.skill-modal__dialog--create .skill-modal__tab:hover:not(:disabled) {
  color: var(--fg-text-purple, #7362c2);
}

.skill-modal__dialog--create .skill-modal__tab--active {
  background: transparent;
  border-bottom-color: var(--fg-text-basic, #3b3b3b);
  color: var(--fg-text-basic, #3b3b3b);
  box-shadow: none;
}

/* 라벨 (14px Bold) */
.skill-modal__dialog--create .skill-modal__label {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  color: var(--fg-text-basic, #3b3b3b);
}

.skill-modal__label-row {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.skill-modal__hint-block {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--fg-text-gray, #838383);
}

.skill-modal__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* 입력 / 텍스트영역 */
.skill-modal__dialog--create .skill-modal__input,
.skill-modal__dialog--create .skill-modal__textarea {
  width: 100%;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
  box-sizing: border-box;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.skill-modal__dialog--create .skill-modal__input::placeholder,
.skill-modal__dialog--create .skill-modal__textarea::placeholder {
  color: var(--fg-text-gray, #838383);
}

.skill-modal__dialog--create .skill-modal__textarea {
  min-height: 112px;
  resize: vertical;
}

.skill-modal__dialog--create .skill-modal__textarea--code {
  min-height: 160px;
  font-family: 'JetBrains Mono', 'Consolas', 'Menlo', monospace;
  font-size: 14px;
  line-height: 22px;
}

.skill-modal__dialog--create .skill-modal__input:focus,
.skill-modal__dialog--create .skill-modal__textarea:focus {
  outline: none;
  border-color: var(--fg-button, #978cca);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);
}

/* "다시 생성" 툴바형 버튼 */
.skill-modal__regen {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp, #e8eaf5);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-button-hover, #7362c2);
  cursor: pointer;
  transition: background-color 120ms ease;
}

.skill-modal__regen:hover:not(:disabled) {
  background: var(--fg-bg-litepp-hover, #cbd1ef);
}

.skill-modal__regen:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 푸터 — 중앙 정렬 (저장/취소) */
.skill-modal__foot--centered {
  justify-content: center;
  gap: 8px;
  padding: 12px 20px 20px;
  border-top: 0;
}

.skill-modal__dialog--create .skill-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  height: auto;
  padding: 6px 12px;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: background-color 120ms ease, opacity 120ms ease;
}

.skill-modal__dialog--create .skill-modal__btn--primary {
  background: var(--fg-button, #978cca);
  color: #fff;
  border: 0;
}

.skill-modal__dialog--create .skill-modal__btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover, #7362c2);
}

.skill-modal__btn--cancel {
  background: var(--fg-text-gray, #838383);
  color: #fff;
  border: 0;
}

.skill-modal__btn--cancel:hover:not(:disabled) {
  background: #6b6b6b;
}


/* =====================================================
   Workflow + 버튼 모달 (WorkflowModals)
   라이트 테마 — SkillDetailModal 과 같은 톤
   ===================================================== */
.workflow-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: skill-modal-fade-in 120ms ease-out;
}

.workflow-modal__dialog {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  animation: skill-modal-pop-in 160ms ease-out;
}

.workflow-modal__dialog--wide {
  max-width: 1120px;
}

/* 검색 리스트형 모달 — 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */
.workflow-modal__dialog--fixed-height {
  height: calc(100vh - 64px);
}

.workflow-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--fg-line);
}

.workflow-modal__head-text {
  min-width: 0;
}

.workflow-modal__eyebrow {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--fg-text-gray);
}

.workflow-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--fg-text-basic);
}

.workflow-modal__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.workflow-modal__close:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.workflow-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.workflow-modal__footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--fg-line);
  background: var(--fg-bg-card);
}

.workflow-modal__spacer {
  flex: 1 1;
}

.workflow-modal__btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__btn--ghost {
  background: #fff;
  border-color: var(--fg-line);
  color: var(--fg-text-basic);
}

.workflow-modal__btn--ghost:hover:not(:disabled) {
  background: var(--fg-bg-card);
}

.workflow-modal__btn--primary {
  background: var(--fg-button);
  color: #fff;
}

.workflow-modal__btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.workflow-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── [DRAFT] KB 모달 원본파일 리스트 (신규 UI 초안) ─── */
.workflow-modal__origin-list {
  margin-bottom: 16px;
  padding: 12px 14px 10px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.workflow-modal__origin-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.workflow-modal__origin-list-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.workflow-modal__origin-list-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  font-size: 11px;
  font-weight: 700;
  color: var(--fg-button);
  background: color-mix(in srgb, var(--fg-button) 12%, transparent);
  border-radius: 999px;
}

.workflow-modal__origin-list-all {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-button);
  background: transparent;
  border: 1px solid color-mix(in srgb, var(--fg-button) 40%, transparent);
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__origin-list-all:hover {
  background: color-mix(in srgb, var(--fg-button) 8%, transparent);
}

.workflow-modal__origin-list-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.workflow-modal__origin-list-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  font-family: inherit;
  text-align: left;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  transition: var(--transition-fast);
}

.workflow-modal__origin-list-item:hover {
  border-color: var(--fg-button);
  background: var(--fg-bg-liteblue);
}

.workflow-modal__origin-list-item-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.workflow-modal__origin-list-item-footer {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--fg-line);
}

.workflow-modal__origin-list-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

.workflow-modal__origin-list-item-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
}

.workflow-modal__origin-list-item-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workflow-modal__origin-list-item-meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--fg-text-gray);
}

.workflow-modal__origin-list-item-dot {
  opacity: 0.5;
}

.workflow-modal__origin-list-item-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  height: 32px;
  padding: 0 10px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__origin-list-item-action-btn--import {
  color: #fff;
  background: var(--fg-button);
  border: 1px solid var(--fg-button);
}

.workflow-modal__origin-list-item-action-btn--import:hover:not(:disabled) {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
}

.workflow-modal__origin-list-item-action-btn--download {
  color: var(--fg-text-basic);
  background: #fff;
  border: 1px solid var(--fg-line);
}

.workflow-modal__origin-list-item-action-btn--download:hover:not(:disabled) {
  color: var(--fg-button);
  border-color: var(--fg-button);
  background: var(--fg-bg-liteblue);
}

.workflow-modal__origin-list-item-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.workflow-modal__origin-list-hint {
  margin: 10px 0 0;
  padding-top: 8px;
  font-size: 11px;
  color: var(--fg-text-gray);
  border-top: 1px dashed var(--fg-line);
}

/* ─── KB 모달 원본파일 다운로드 배너 ─── */
.workflow-modal__origin-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 10px 14px;
  background: color-mix(in srgb, var(--fg-button) 8%, var(--fg-bg-card));
  border: 1px solid color-mix(in srgb, var(--fg-button) 24%, transparent);
  border-radius: 8px;
}

.workflow-modal__origin-banner-text {
  font-size: 13px;
  color: var(--fg-text-basic);
  line-height: 1.4;
}

.workflow-modal__origin-banner-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-button);
  background: #fff;
  border: 1px solid color-mix(in srgb, var(--fg-button) 40%, transparent);
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__origin-banner-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--fg-button) 10%, #fff);
  border-color: var(--fg-button);
}

.workflow-modal__origin-banner-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.workflow-modal__origin-banner-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid color-mix(in srgb, var(--fg-button) 30%, transparent);
  border-top-color: var(--fg-button);
  border-radius: 50%;
  animation: workflow-modal__origin-spin 0.8s linear infinite;
}

@keyframes workflow-modal__origin-spin {
  to {
    transform: rotate(360deg);
  }
}

.workflow-modal__inline-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--fg-text-basic);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.workflow-modal__inline-toggle input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

/* 검색 input */
.workflow-modal__search {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 30px;
}

.workflow-modal__search-input {
  flex: 1 1;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 13px;
  background: transparent;
  color: var(--fg-text-basic);
}

.workflow-modal__search-input::placeholder {
  color: var(--fg-text-gray);
}

/* 카테고리 필터 칩 */
.workflow-modal__cat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 10px 0 4px;
}

.workflow-modal__cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__cat-chip:hover:not(:disabled) {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.workflow-modal__cat-chip--active {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}

.workflow-modal__cat-chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.workflow-modal__cat-chip-count {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 16px;
  padding: 0 5px;
  background: var(--fg-bg-litepp);
  color: var(--fg-text-gray);
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;
  line-height: 1;
}

.workflow-modal__cat-chip--active .workflow-modal__cat-chip-count {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

/* 멀티셀렉트 리스트 */
.workflow-modal__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workflow-modal__list-item {
  display: flex;
}

.workflow-modal__list-btn {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: var(--transition-fast);
}

.workflow-modal__list-btn:hover {
  border-color: var(--fg-button);
  background: var(--fg-bg-liteblue);
}

.workflow-modal__list-item--selected .workflow-modal__list-btn {
  border-color: var(--fg-button);
  background: var(--fg-bg-liteblue);
}

.workflow-modal__check {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 4px;
  margin-top: 1px;
  transition: var(--transition-fast);
}

.workflow-modal__check--on {
  background: var(--fg-button);
  border-color: var(--fg-button);
}

.workflow-modal__list-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.workflow-modal__list-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
  word-break: break-word;
}

.workflow-modal__list-desc {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1.4;
  word-break: break-word;
}

.workflow-modal__empty {
  padding: 20px 12px;
  text-align: center;
  font-size: 13px;
  color: var(--fg-text-gray);
}

/* 폼 (스케줄 모달) */
.workflow-modal__form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.workflow-modal__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.workflow-modal__field-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.workflow-modal__field-input {
  padding: 9px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  outline: none;
  transition: var(--transition-fast);
}

.workflow-modal__field-input:focus {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px var(--fg-bg-liteblue);
}

.workflow-modal__field-hint {
  font-size: 11px;
  color: var(--fg-text-gray);
}

/* 스케줄 모달 — 기존 스케줄 리스트 */
.workflow-modal__schedule-existing {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--fg-line);
}

.workflow-modal__list-btn--static {
  cursor: default;
}

.workflow-modal__list-btn--static:hover {
  border-color: var(--fg-line);
  background: #fff;
}

.workflow-modal__schedule-del {
  margin-left: 8px;
  align-self: center;
}

/* 탭 (CHANNELS 모달) */
.workflow-modal__tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.workflow-modal__tab {
  flex: 1 1;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__tab:hover {
  color: var(--fg-text-basic);
}

.workflow-modal__tab--active {
  background: #fff;
  color: var(--fg-text-basic);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

/* provider/channel row */
.workflow-modal__provider-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.workflow-modal__provider-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.workflow-modal__provider-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

.workflow-modal__provider-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.workflow-modal__provider-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.workflow-modal__provider-meta {
  font-size: 11px;
  color: var(--fg-text-gray);
}

/* iOS 스타일 토글 스위치 */
.workflow-modal__switch {
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 22px;
  display: inline-block;
}

.workflow-modal__switch input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.workflow-modal__switch-thumb {
  position: absolute;
  inset: 0;
  background: var(--fg-line);
  border-radius: 30px;
  transition: var(--transition-fast);
}

.workflow-modal__switch-thumb::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: var(--transition-fast);
}

.workflow-modal__switch input:checked+.workflow-modal__switch-thumb {
  background: var(--fg-button);
}

.workflow-modal__switch input:checked+.workflow-modal__switch-thumb::after {
  transform: translateX(18px);
}

.workflow-modal__switch input:disabled+.workflow-modal__switch-thumb {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── KB 모달 신규 레이아웃 — 공유 원본 접힘 / 검색+업로드 한 줄 / 선택됨 sticky 섹션 ─── */
.workflow-modal__origin-list--collapsible {
  padding: 10px 14px;
}

.workflow-modal__origin-list--collapsible .workflow-modal__origin-list-head {
  margin-bottom: 0;
}

.workflow-modal__origin-list--collapsible.workflow-modal__origin-list--open {
  padding-bottom: 12px;
}

.workflow-modal__origin-list--collapsible.workflow-modal__origin-list--open .workflow-modal__origin-list-head {
  margin-bottom: 10px;
}

.workflow-modal__origin-list-title--btn {
  padding: 2px 0;
  font-family: inherit;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--fg-text-basic);
}

.workflow-modal__origin-list-title--btn:hover {
  color: var(--fg-button);
}

.workflow-modal__origin-list-chev {
  color: var(--fg-text-gray);
  transition: transform 0.18s ease, color 0.18s ease;
}

.workflow-modal__origin-list--open .workflow-modal__origin-list-chev {
  transform: rotate(90deg);
  color: var(--fg-button);
}

.workflow-modal__search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.workflow-modal__search-row .workflow-modal__search {
  flex: 1 1;
}

.workflow-modal__upload-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-button);
  background: #fff;
  border: 1px dashed color-mix(in srgb, var(--fg-button) 45%, transparent);
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition-fast);
  white-space: nowrap;
}

.workflow-modal__upload-toggle:hover {
  background: color-mix(in srgb, var(--fg-button) 8%, #fff);
  border-color: var(--fg-button);
}

.workflow-modal__upload-toggle--active {
  color: #fff;
  background: var(--fg-button);
  border-color: var(--fg-button);
  border-style: solid;
}

.workflow-modal__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.workflow-modal__section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 2px;
  background: #fff;
}

.workflow-modal__section-head--sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 10px 2px 8px;
  margin: -6px -2px 0;
  border-bottom: 1px solid var(--fg-line);
  box-shadow: 0 6px 8px -8px rgba(0, 0, 0, 0.18);
}

.workflow-modal__section-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fg-text-gray);
}

.workflow-modal__section-count {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  font-size: 11px;
  font-weight: 700;
  color: var(--fg-button);
  background: color-mix(in srgb, var(--fg-button) 12%, transparent);
  border-radius: 999px;
}

.workflow-modal__section-clear {
  margin-left: auto;
  padding: 4px 10px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray);
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.workflow-modal__section-clear:hover {
  color: var(--fg-anti-red, #c5343a);
  background: var(--fg-bg-card);
}

/* ─── Origin 노드 편집 — 우측 슬라이드 패널 ─── */
.agent-edit__overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  pointer-events: none;
  background: transparent;
  transition: background 0.25s ease;
}

.agent-edit__overlay--open {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.18);
}

.agent-edit__panel {
  position: absolute;
  top: 0;
  right: 0;
  width: min(760px, 92vw);
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.12);
  transform: translateX(100%);
  transition: transform 0.28s ease;
}

.agent-edit__overlay--open .agent-edit__panel {
  transform: translateX(0);
}

.agent-edit__panel-head {
  flex-shrink: 0;
  padding: 16px 20px 14px;
  border-bottom: 1px solid var(--fg-line);
  background: var(--fg-bg-card, #fafafa);
}

.agent-edit__panel-head-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.agent-edit__panel-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.agent-edit__panel-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agent-edit__panel-save {
  background: var(--fg-button);
  border: 1px solid var(--fg-button);
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__panel-save:hover:not(:disabled) {
  background: var(--fg-button-hover);
  border-color: var(--fg-button-hover);
}

.agent-edit__panel-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agent-edit__panel-close {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-edit__panel-close:hover {
  background: var(--fg-line);
  color: var(--fg-text-basic);
}

.agent-edit__panel-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agent-edit__panel-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agent-edit__panel-field>span {
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-gray);
}

.agent-edit__panel-field input,
.agent-edit__panel-field select {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  outline: none;
  transition: var(--transition-fast);
}

.agent-edit__panel-field input:focus,
.agent-edit__panel-field select:focus {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);
}

/* 폴더 multi-select 필드 */
.agent-edit__folder {
  position: relative;
}

.agent-edit__folder-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 36px;
  padding: 4px 6px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  cursor: text;
  transition: var(--transition-fast);
}

.agent-edit__folder-chips:focus-within {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);
}

.agent-edit__folder-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 24px;
  padding: 0 4px 0 8px;
  background: var(--fg-bg-mychat);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-button-hover);
}

.agent-edit__folder-chip-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
}

.agent-edit__folder-chip-x:hover {
  background: rgba(86, 60, 240, 0.15);
}

.agent-edit__folder .agent-edit__folder-input {
  flex: 1 1;
  min-width: 100px;
  width: auto;
  height: 26px;
  padding: 0 4px;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  outline: none;
}

.agent-edit__folder .agent-edit__folder-input:focus {
  border: 0;
  box-shadow: none;
}

.agent-edit__folder-suggest {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  box-shadow: var(--shadow-md);
  max-height: 200px;
  overflow-y: auto;
}

.agent-edit__folder-suggest-item {
  display: block;
  width: 100%;
  padding: 6px 8px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  text-align: left;
  font-family: inherit;
  font-size: 13px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.agent-edit__folder-suggest-item:hover {
  background: var(--fg-bg-mychat);
}

.agent-edit__panel-body {
  flex: 1 1;
  min-height: 0;
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
}

.agent-edit__panel-textarea {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  resize: none;
  padding: 14px 16px;
  background: var(--fg-bg-card, #fafafa);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;
  font-size: 13px;
  line-height: 22px;
  color: var(--fg-text-basic);
  outline: none;
  transition: var(--transition-fast);
}

.agent-edit__panel-textarea:focus {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);
}

/* ────────────────────────────────────────────────────────────
 * AgentExportModal — 발행(공유 링크) 관리 모달
 * ────────────────────────────────────────────────────────── */
.agent-export__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: agent-export-fade 160ms ease-out;
}

@keyframes agent-export-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.agent-export__dialog {
  width: 100%;
  max-width: 640px;
  max-height: min(80vh, 720px);
  background: var(--fg-bg-card, #fff);
  border-radius: 20px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18), 0 6px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font-sans);
  animation: agent-export-slide 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes agent-export-slide {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.agent-export__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--fg-line);
}

.agent-export__header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.agent-export__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.agent-export__subtitle {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: var(--fg-text-gray);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-export__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-export__close:hover {
  background: var(--fg-bg-content);
  color: var(--fg-text-basic);
}

.agent-export__body {
  flex: 1 1;
  min-height: 0;
  padding: 16px 24px;
  overflow-y: auto;
}

.agent-export__empty {
  margin: 0;
  padding: 48px 0;
  text-align: center;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.agent-export__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agent-export__item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.agent-export__item:hover {
  border-color: var(--fg-button);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
}

.agent-export__item--inactive {
  opacity: 0.7;
  background: var(--fg-bg-content);
}

.agent-export__item-top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.agent-export__badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  letter-spacing: 0.02em;
}

.agent-export__badge--active {
  color: #0a7c4d;
  background: rgba(16, 185, 129, 0.12);
}

.agent-export__badge--inactive {
  color: var(--fg-text-gray);
  background: rgba(0, 0, 0, 0.06);
}

.agent-export__meta {
  font-size: 12px;
  color: var(--fg-text-gray);
}

.agent-export__url-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.agent-export__url {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-export__actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.agent-export__icon-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-export__icon-btn:hover:not(:disabled) {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.agent-export__icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agent-export__icon-btn--danger {
  color: var(--fg-anti-red);
}

.agent-export__icon-btn--danger:hover:not(:disabled) {
  border-color: var(--fg-anti-red);
  background: rgba(239, 68, 68, 0.06);
  color: var(--fg-anti-red);
}

.agent-export__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px 20px;
  border-top: 1px solid var(--fg-line);
}

.agent-export__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  transition: var(--transition-fast);
  border: 1px solid transparent;
}

.agent-export__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.agent-export__btn--secondary {
  background: #fff;
  border-color: var(--fg-line);
  color: var(--fg-text-basic);
}

.agent-export__btn--secondary:hover:not(:disabled) {
  border-color: var(--fg-text-gray);
  background: var(--fg-bg-content);
}

.agent-export__btn--primary {
  background: var(--fg-button);
  color: #fff;
}

.agent-export__btn--primary:hover:not(:disabled) {
  filter: brightness(1.05);
  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);
}


/* ── QR 코드 보기 모달 ── */
.agent-export__overlay--qr {
  z-index: 1010;
  background: rgba(15, 23, 42, 0.65);
}

.agent-export__qr-dialog {
  width: 100%;
  max-width: 360px;
  background: var(--fg-bg-card, #fff);
  border-radius: 20px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.22), 0 6px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font-sans);
  animation: agent-export-slide 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

.agent-export__qr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--fg-line);
}

.agent-export__qr-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: var(--fg-text-basic);
}

.agent-export__qr-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.agent-export__qr-image {
  display: block;
  width: 220px;
  height: 220px;
  object-fit: contain;
  background: #fff;
  padding: 8px;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.agent-export__qr-url {
  margin: 0;
  max-width: 100%;
  font-size: 12px;
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  color: var(--fg-text-gray);
  text-align: center;
  word-break: break-all;
}

.agent-export__qr-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 16px;
  border-top: 1px solid var(--fg-line);
}

.agent-export__qr-footer .agent-export__btn--primary {
  text-decoration: none;
}

/* ========================================================================
   모바일 (≤720px) — 에이전트 [1단계: 사이드바].
   AgentSidebar(섹션 내비 + 대화 목록)는 AI채팅 패턴: 접힘 = 좌상단 플로팅 토글,
   펼침 = 오버레이 드로어. 공유 셸을 쓰므로 .agent-page 로 스코프해 타 기능 영향 차단.
   ※ 카드 그리드/채팅/2-pane 등 본문 반응형은 후속 단계에서 처리.
   ======================================================================== */
@media (max-width: 720px) {
  /* 카드 셸 여백 제거 — 폭 확보 */
  .agent-page .prompt__layout {
    margin: 0;
    border-radius: 0;
  }

  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림).
     .agent__sidebar 의 max-height: calc(100vh - 52px)(데스크톱 sticky용)를 풀어
     드로어가 화면 끝까지 차게 한다(하단 갭 제거). 100dvh 로 모바일 주소창까지 보정. */
  .agent-page .prompt__sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 84vw;
    max-width: 320px;
    max-height: none;
    height: 100vh;
    height: 100dvh;
    z-index: 200;
    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);
  }

  /* 접힘 = AI채팅과 동일: 레일 대신 좌상단 플로팅 토글 버튼만, 본문은 풀폭 */
  .agent-page .prompt__sidebar--collapsed {
    position: fixed;
    top: 60px;
    left: 12px;
    bottom: auto;
    width: auto;
    padding: 0;
    gap: 0;
    background: transparent;
    box-shadow: none;
    z-index: 60;
  }

  .agent-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {
    display: none;
  }

  .agent-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    color: var(--fg-text-basic);
  }

  /* 본문 여백 + 플로팅 토글과 안 겹치게 제목 줄 들여쓰기 (prompt-intro 헤더 쓰는 화면) */
  .agent-page .prompt__content {
    padding: 16px 14px;
    gap: 24px;
  }

  .agent-page .prompt-intro__heading {
    min-height: 40px;
    padding-left: 48px;
  }

  /* ── [2단계] AgentList / AgentSkills — 그리드 1열 + 공유 툴바 정리 ── */
  .agent-page .agent-list__cards--grid,
  .agent-page .agent-list__cards--list,
  .agent-page .agent-skills__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .agent-page .prompt-list__stats-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .agent-page .prompt-list__stats {
    flex-wrap: wrap;
    gap: 6px 8px;
  }

  .agent-page .prompt-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .agent-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  /* 그리드/리스트 토글은 1열 고정이라 무의미 → 숨김 */
  .agent-page .prompt-list__view-toggle {
    display: none;
  }

  /* ── [3단계] AgentChat — 대화 화면 ── */
  /* 100dvh 로 모바일 주소창 보정 (헤더 ~48px) */
  .agent-page .agent-chat__main {
    height: calc(100dvh - 48px);
  }

  /* 툴바: 좌측에 플로팅 사이드바 토글 자리 확보 + 제목 말줄임 */
  .agent-page .agent-edit__toolbar {
    padding-left: 60px;
  }

  .agent-page .agent-edit__toolbar-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 우측 버튼(내보내기/Workflow/Folder)은 좁아서 텍스트 숨기고 아이콘만 */
  .agent-page .agent-edit__tb-btn span {
    display: none;
  }

  .agent-page .agent-edit__tb-group {
    gap: 4px;
  }

  /* 2-pane 우측 패널(workflow/folder) → 풀스크린 오버레이 시트.
     자체 헤더/닫기 버튼이 있어 독립적으로 닫힌다. 메인 채팅영역은 뒤에서 풀폭 유지. */
  .agent-page .agent-chat__panel {
    position: fixed;
    inset: 0;
    z-index: 150;
    flex: none;
    width: 100%;
    max-width: 100%;
    box-shadow: none;
  }

  /* 입력 영역 여백 축소 */
  .agent-page .agent-chat__input-area {
    padding: 10px 12px;
  }

  /* AgentCreate — 입력창 아래 예시(프리셋) 4개는 모바일에서 숨김 */
  .agent-page .agent-create__presets {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Agent.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,uEAAuE;AACzE;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;6EAE6E;;AAE7E;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,yDAAyD;AAC3D;;AAEA;;EAEE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,6BAA6B;EAC7B,sDAAsD;AACxD;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,6EAA6E;EAC7E,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,UAAU;EACV,kHAAkH;AACpH;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;;EAEE;;IAEE,6CAA6C;EAC/C;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;EACxD,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;EACV,sDAAsD;EACtD,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;;AAGA;;6EAE6E;;AAE7E;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,MAAM;AACR;;AAEA;;6EAE6E;;AAE7E;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;6EAE6E;;AAE7E;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;gFAGgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,oEAAoE;AACtE;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,mCAAmC;EACnC,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;;;oCAGkC;EAClC,0BAA0B;EAC1B,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,WAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,wDAAwD;EACxD,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;EAClB,wDAAwD;EACxD,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;0DAI0D;AAC1D;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,SAAS;EACT,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;;0DAE0D;AAC1D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;;AAGA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,yCAAyC;EACzC,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;;EAEE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,oBAAoB;EACpB,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;0DAE0D;AAC1D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;EAClD,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;;EAEE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;;0DAG0D;AAC1D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iEAAiE;EACjE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,uEAAuE;EACvE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sEAAsE;EACtE,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uEAAuE;EACvE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,kCAAkC;EAClC,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,wEAAwE;EACxE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iEAAiE;EACjE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,mBAAmB;EACnB,wDAAwD;EACxD,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;EACnB,2EAA2E;EAC3E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;AACnE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,6EAA6E;EAC7E,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;;AAGA,sBAAsB;AACtB;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,2EAA2E;EAC3E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,6EAA6E;EAC7E,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;6EAK6E;AAC7E;EACE,sBAAsB;EACtB;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;;yDAEuD;EACvD;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,6EAA6E;EAC/E;;EAEA,gDAAgD;EAChD;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,UAAU;IACV,MAAM;IACN,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA,4DAA4D;EAC5D;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,4DAA4D;EAC5D;;;IAGE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;;EAEA,kCAAkC;EAClC,mCAAmC;EACnC;IACE,2BAA2B;EAC7B;;EAEA,uCAAuC;EACvC;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,kDAAkD;EAClD;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;qDACmD;EACnD;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;EACpB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;AACF","sourcesContent":["/* ========================================================================\n   Agent — 에이전트 빌더 영역\n   사이드바·인트로·필터 공통 스타일은 Prompt.css 재사용\n   ======================================================================== */\n\n/* ───────── 사이드바 — 대화 목록 섹션 추가 ───────── */\n.agent__sidebar {\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 0;\n  max-height: calc(100vh - 52px);\n  overflow: hidden;\n}\n\n.agent__sidebar-chats {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--fg-line);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n}\n\n.agent__sidebar-section-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent__sidebar-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px 6px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n}\n\n.agent__sidebar-search-input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-size: 13px;\n  background: transparent;\n  color: var(--fg-text-basic);\n}\n\n.agent__sidebar-search-input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.agent__sidebar-search>svg {\n  flex-shrink: 0;\n  color: var(--fg-text-gray);\n}\n\n.agent__sidebar-chat-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow-y: auto;\n}\n\n.agent__sidebar-chat-item {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 8px;\n  background: #fff;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent__sidebar-chat-item:hover,\n.agent__sidebar-chat-item--active {\n  background: var(--fg-bg-liteblue);\n  border-color: var(--fg-button-hover);\n}\n\n.agent__sidebar-chat-delete {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: #fff;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.agent__sidebar-chat-item:hover .agent__sidebar-chat-delete,\n.agent__sidebar-chat-item--active .agent__sidebar-chat-delete {\n  visibility: visible;\n  opacity: 1;\n}\n\n.agent__sidebar-chat-delete:hover {\n  color: var(--fg-anti-red);\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.agent__sidebar-chat-icon {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-purple);\n  margin-top: 2px;\n}\n\n.agent__sidebar-chat-body {\n  flex: 1 1 0%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.agent__sidebar-chat-eyebrow {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-purple);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent__sidebar-chat-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #464646;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent__sidebar-chat-time {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.agent__sidebar-chat-empty {\n  padding: 8px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n/* ───────── AgentList 폴더 탭 ───────── */\n.agent-list__folder-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  margin: 12px 0 16px;\n}\n\n.agent-list__folder-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 2px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-list__folder-tab:hover {\n  color: var(--fg-text-basic);\n}\n\n.agent-list__folder-tab--active {\n  color: var(--fg-text-basic);\n  border-bottom-color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n.agent-list__folder-tab-count {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n/* ───────── AgentList 카드 ───────── */\n.agent-list__cards {\n  display: grid;\n  gap: 20px;\n  grid-auto-rows: 1fr;\n  align-items: stretch;\n}\n\n.agent-list__cards--grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.agent-list__cards--list {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1280px) {\n  .agent-list__cards--grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.agent-list__card {\n  display: flex;\n  gap: 12px;\n  padding: 16px 20px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n  height: 100%;\n  min-height: 240px;\n  box-sizing: border-box;\n}\n\n.agent-list__card:hover {\n  border-color: var(--fg-button);\n}\n\n.agent-list__card--selected {\n  border-color: var(--fg-side-hover);\n  box-shadow: 0 0 0 1px var(--fg-side-hover);\n}\n\n.agent-list__card-check {\n  flex-shrink: 0;\n  padding-top: 3px;\n}\n\n.agent-list__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agent-list__card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agent-list__card-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-list__card-date {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.agent-list__card-summary {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  height: 44px;\n  word-break: break-word;\n}\n\n/* 대화/발행 액션 */\n.agent-list__card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.agent-list__action {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 16px 20px;\n  background: var(--fg-bg-mychat);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-button-hover);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-list__action:hover {\n  background: #d8dbed;\n}\n\n.agent-list__action--publishing {\n  background: #c7ffeb;\n  border-color: #c7ffeb;\n  color: var(--fg-text-basic);\n  padding: 14px 20px;\n}\n\n.agent-list__action--publishing:hover {\n  background: #b3f5dc;\n  border-color: #b3f5dc;\n}\n\n/* 카드 footer (폴더 칩 좌측 + 공유/삭제 우측) */\n.agent-list__card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: auto;\n  min-height: 28px;\n}\n\n.agent-list__card-folders {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n}\n\n.agent-list__card-folder-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 80px;\n  height: 20px;\n  padding: 0 8px;\n  background: var(--fg-bg-mychat);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--fg-button-hover);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n}\n\n.agent-list__card-folder-chip--more {\n  padding: 0 6px;\n  background: transparent;\n  color: var(--fg-text-gray);\n}\n\n.agent-list__card-footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* ========================================================================\n   AgentCreate — 새 에이전트 만들기 (Figma 76:7049)\n   ======================================================================== */\n\n.agent-create__main {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agent-create__center {\n  width: 100%;\n  max-width: 760px;\n  padding: 60px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.agent-create__title {\n  margin: 0;\n  font-size: 36px;\n  font-weight: 600;\n  text-align: left;\n  color: var(--fg-text-basic);\n  line-height: 46px;\n}\n\n.agent-create__subtitle {\n  margin: 10px 0 40px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  text-align: left;\n}\n\n.agent-create__input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 20px;\n  background: #fff;\n  border-radius: 30px;\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2);\n}\n\n.agent-create__input {\n  flex: 1;\n  min-width: 0;\n  min-height: 26px;\n  max-height: 160px;\n  border: 0;\n  outline: none;\n  resize: none;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  background: transparent;\n  padding: 0;\n  overflow-y: hidden;\n}\n\n.agent-create__input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.agent-create__send {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  color: var(--fg-button);\n  padding: 0;\n}\n\n.agent-create__send:hover {\n  color: var(--fg-button-hover);\n}\n\n.agent-create__send:disabled {\n  color: var(--fg-text-gray);\n  cursor: not-allowed;\n}\n\n.agent-create__input:disabled {\n  cursor: not-allowed;\n}\n\n.agent-create__status {\n  margin: 14px 0 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  align-self: center;\n  padding: 8px 14px;\n  background: var(--fg-bg-card, #f5f5f7);\n  border-radius: 999px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.agent-create__presets {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n/* 질문 단계 — 가운데 정렬 + 카드 폼 */\n.agent-create__center--questions {\n  padding-top: 80px;\n}\n\n.agent-create__qheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.agent-create__qhint {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.agent-create__qrestart {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-button);\n  cursor: pointer;\n}\n\n.agent-create__qrestart:hover {\n  color: var(--fg-button-hover);\n  text-decoration: underline;\n}\n\n.agent-create__qcard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  padding: 20px;\n  animation: agent-qcard-in 200ms ease-out;\n}\n\n.agent-create__qcard-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n@keyframes agent-qcard-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agent-create__qcard-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: normal;\n  color: var(--fg-text-basic, #3b3b3b);\n  word-break: keep-all;\n}\n\n.agent-create__qcard-subtitle {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.agent-create__qopts {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 24px;\n  width: 100%;\n}\n\n.agent-create__qopt {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  transition: opacity 120ms ease;\n}\n\n.agent-create__qopt:hover .agent-create__qopt-box {\n  border-color: var(--fg-button, #978cca);\n}\n\n.agent-create__qopt-input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 0;\n  height: 0;\n}\n\n.agent-create__qopt-box {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: var(--gray---c2c2c2, #c2c2c2);\n  border: 0;\n  border-radius: 4px;\n  color: #fff;\n  transition: background-color 120ms ease;\n}\n\n.agent-create__qopt-box>svg {\n  visibility: hidden;\n}\n\n.agent-create__qopt-input:checked+.agent-create__qopt-box {\n  background: var(--fg-button, #978cca);\n}\n\n.agent-create__qopt-input:checked+.agent-create__qopt-box>svg {\n  visibility: visible;\n}\n\n.agent-create__qopt-label {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n  white-space: nowrap;\n}\n\n.agent-create__qfooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 0;\n  border: 0;\n}\n\n.agent-create__qfooter-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agent-create__qfooter-page {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray, #838383);\n}\n\n.agent-create__qfooter-back,\n.agent-create__qfooter-skip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  padding: 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.agent-create__qfooter-back:hover:not(:disabled),\n.agent-create__qfooter-skip:hover {\n  background: var(--fg-bg-litepp, #e8eaf5);\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.agent-create__qfooter-back:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.agent-create__qfooter-next {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 12px 7px;\n  background: var(--fg-button, #978cca);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 120ms ease;\n}\n\n.agent-create__qfooter-next:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n\n/* ─── 빌드 진행 화면 ─── */\n.agent-create__pcard {\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 16px;\n  padding: 24px 28px 28px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n  animation: agent-create-q-fade 0.18s ease-out;\n}\n\n.agent-create__pcard--done {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 1px var(--fg-button), 0 6px 18px rgba(0, 0, 0, 0.06);\n}\n\n.agent-create__pbar {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 6px;\n  margin-bottom: 18px;\n}\n\n.agent-create__pbar-seg {\n  height: 4px;\n  border-radius: 999px;\n  background: var(--fg-line);\n  transition: background 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.agent-create__pbar-seg--done {\n  background: var(--fg-button);\n}\n\n.agent-create__pbar-seg--active {\n  background: var(--fg-line);\n}\n\n.agent-create__pbar-seg--active::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--fg-button);\n  transform-origin: left center;\n  animation: agent-create-pbar-grow 4.2s linear forwards;\n}\n\n@keyframes agent-create-pbar-grow {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n.agent-create__ptitle {\n  margin: 0 0 18px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* Phase 1 — Workflow Canvas */\n.agent-create__pv-canvas {\n  position: relative;\n  height: 220px;\n  background: linear-gradient(180deg, var(--fg-bg-card, #fafafa) 0%, #fff 100%);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.agent-create__pv-canvas svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.agent-create__pv-line {\n  stroke: var(--fg-button);\n  stroke-width: 1.5;\n  stroke-dasharray: 4 4;\n  opacity: 0;\n  animation: agent-create-line-in 0.6s ease-out forwards;\n}\n\n.agent-create__pv-particle {\n  fill: var(--fg-button);\n}\n\n@keyframes agent-create-line-in {\n  to {\n    opacity: 0.55;\n  }\n}\n\n.agent-create__pv-node {\n  position: absolute;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  color: var(--fg-text-basic);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  opacity: 0;\n  animation: agent-create-node-in 0.4s ease-out forwards;\n}\n\n@keyframes agent-create-node-in {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.agent-create__pv-center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 10px 22px;\n  background: var(--fg-button);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(86, 60, 240, 0.3);\n  opacity: 0;\n  animation: agent-create-center-pulse 1.8s ease-out forwards, agent-create-center-glow 2s ease-in-out 1.6s infinite;\n}\n\n@keyframes agent-create-center-pulse {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.7);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes agent-create-center-glow {\n\n  0%,\n  100% {\n    box-shadow: 0 4px 12px rgba(86, 60, 240, 0.3);\n  }\n\n  50% {\n    box-shadow: 0 4px 20px rgba(86, 60, 240, 0.55);\n  }\n}\n\n/* Phase 2 — Editor */\n.agent-create__pv-editor {\n  height: 220px;\n  background: #1e1e2e;\n  border-radius: 12px;\n  padding: 16px 18px;\n  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;\n  font-size: 12.5px;\n  line-height: 22px;\n  overflow: hidden;\n}\n\n.agent-create__pv-editor-line {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  opacity: 0;\n  transform: translateY(4px);\n  animation: agent-create-editor-in 0.32s ease-out forwards;\n}\n\n@keyframes agent-create-editor-in {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agent-create__pv-editor-num {\n  flex-shrink: 0;\n  width: 18px;\n  text-align: right;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.agent-create__pv-editor-text {\n  color: #d4d4dc;\n}\n\n.agent-create__pv-editor-cursor {\n  display: inline-block;\n  width: 6px;\n  height: 14px;\n  margin-left: 4px;\n  background: var(--fg-button);\n  vertical-align: middle;\n  animation: agent-create-blink 0.9s steps(2) infinite;\n}\n\n@keyframes agent-create-blink {\n  to {\n    opacity: 0;\n  }\n}\n\n.agent-create__hl-keyword {\n  color: #c586c0;\n}\n\n.agent-create__hl-string {\n  color: #ce9178;\n}\n\n.agent-create__hl-comment {\n  color: #6a9955;\n  font-style: italic;\n}\n\n/* Phase 3 — Tool Grid */\n.agent-create__pv-tools {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 8px;\n}\n\n.agent-create__pv-tool {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  opacity: 0;\n  animation: agent-create-tool-in 0.3s ease-out forwards;\n}\n\n@keyframes agent-create-tool-in {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agent-create__pv-tool--matched {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-card, #faf8ff);\n  box-shadow: 0 0 0 1px var(--fg-button) inset;\n}\n\n.agent-create__pv-tool--dimmed {\n  opacity: 0.4;\n}\n\n.agent-create__pv-tool-icon {\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-gray);\n}\n\n.agent-create__pv-tool--matched .agent-create__pv-tool-icon {\n  color: var(--fg-button);\n}\n\n.agent-create__pv-tool-name {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-create__pv-tool-check {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-button);\n  border-radius: 50%;\n  color: #fff;\n}\n\n/* Phase 4 — Meta Checklist */\n.agent-create__pv-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agent-create__pv-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  opacity: 0;\n  animation: agent-create-meta-in 0.3s ease-out forwards;\n  transition: var(--transition-fast);\n}\n\n@keyframes agent-create-meta-in {\n  from {\n    opacity: 0;\n    transform: translateX(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.agent-create__pv-meta-row--done {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-card, #faf8ff);\n}\n\n.agent-create__pv-meta-dot {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  border: 1.5px solid var(--fg-line);\n  border-radius: 50%;\n  color: transparent;\n  transition: var(--transition-fast);\n}\n\n.agent-create__pv-meta-dot.is-done {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n\n.agent-create__pv-meta-label {\n  flex: 1;\n  font-size: 13.5px;\n  color: var(--fg-text-basic);\n}\n\n.agent-create__pv-meta--complete .agent-create__pv-meta-row {\n  border-color: var(--fg-button);\n}\n\n.agent-create__preset {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 12px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-create__preset:hover {\n  border-color: var(--fg-button);\n}\n\n.agent-create__preset-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.agent-create__preset-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.agent-create__preset-sub {\n  margin: 2px 0 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n\n/* ========================================================================\n   AgentIntegrations — 외부 서비스 연결 (Figma 76:7677)\n   ======================================================================== */\n\n.agent-int__group {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.agent-int__group-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.agent-int__grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n}\n\n@media (max-width: 1280px) {\n  .agent-int__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* 카드 (시안과 동일 — 작은 가로형) */\n.agent-int__card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  height: 74px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-int__card:hover {\n  border-color: var(--fg-button);\n}\n\n.agent-int__card--on {\n  background: var(--fg-bg-connected);\n}\n\n.agent-int__logo {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n}\n\n.agent-int__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.agent-int__name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.agent-int__desc {\n  margin: 2px 0 0;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Connect 버튼 — 시안의 ButtonConnect (32px 라운드, on 상태 라임그린) */\n.agent-int__connect {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background: var(--fg-bg-card);\n  border: 0;\n  border-radius: 16px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  padding: 4px;\n  transition: var(--transition-fast);\n}\n\n.agent-int__connect:hover {\n  background: #ececec;\n}\n\n.agent-int__connect--on {\n  background: var(--fg-bg-connect-on);\n  color: var(--fg-text-basic);\n}\n\n.agent-int__connect--on:hover {\n  background: #95dd45;\n}\n\n/* ========================================================================\n   AgentSkills — 스킬 카탈로그 (Figma 76:7854)\n   ======================================================================== */\n\n.agent-skills__filter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.agent-skills__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 1280px) {\n  .agent-skills__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.agent-skills__card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.agent-skills__card:hover {\n  border-color: var(--fg-button);\n}\n\n.agent-skills__card--selected {\n  background: var(--fg-bg-step-active);\n  border-color: var(--fg-side-hover);\n}\n\n.agent-skills__body {\n  flex: 1;\n  min-width: 0;\n  padding-top: 1px;\n}\n\n.agent-skills__name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-skills__desc {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.agent-skills__actions {\n  flex-shrink: 0;\n  display: flex;\n  gap: 0;\n}\n\n/* ========================================================================\n   AgentEdit — 편집 화면 (Figma 76:11823 workflow + 78:4980 folder 통합)\n   ======================================================================== */\n\n.agent-edit__main {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.agent-edit__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  padding: 8px 16px;\n  background: var(--fg-bg-toolbar);\n  border-radius: 16px 16px 0 0;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.agent-edit__toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.agent-edit__toolbar-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n}\n\n/* 툴바 버튼 그룹 (segmented) — 1px 간격으로 붙여 표시 */\n.agent-edit__tb-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 1px;\n}\n\n.agent-edit__tb-group>.agent-edit__tb-btn {\n  border-radius: 0;\n}\n\n.agent-edit__tb-group>.agent-edit__tb-btn:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.agent-edit__tb-group>.agent-edit__tb-btn:last-child {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n/* 툴바 버튼 base */\n.agent-edit__tb-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp);\n  border: 0;\n  border-radius: 4px;\n  color: var(--fg-button-hover);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__tb-btn:hover {\n  background: #dde0ee;\n}\n\n.agent-edit__tb-btn--active,\n.agent-edit__tb-btn--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.agent-edit__tb-btn--active:hover,\n.agent-edit__tb-btn--primary:hover {\n  background: var(--fg-button-hover);\n}\n\n.agent-edit__tb-btn--icononly {\n  padding: 5px 7px 7px;\n}\n\n.agent-edit__tb-back {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.agent-edit__tb-back:hover {\n  color: var(--fg-text-purple);\n}\n\n/* 본문: 좌 채팅 + 우 view */\n.agent-edit__body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  overflow: hidden;\n}\n\n/* 좌측 채팅 패널 */\n.agent-edit__chat {\n  flex: 1;\n  min-width: 0;\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-right: 1px solid var(--fg-line);\n}\n\n.agent-edit__chat-toolbar {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px;\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n}\n\n.agent-edit__chat-mode-chip {\n  padding: 6px 12px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 16px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__chat-mode-chip--active {\n  background: var(--fg-bg-mychat);\n  border-color: var(--fg-button-hover);\n  color: var(--fg-button-hover);\n  font-weight: 600;\n}\n\n.agent-edit__chat-scroller {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 32px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.agent-edit__chat-time {\n  align-self: flex-start;\n}\n\n.agent-edit__chat-banner {\n  margin: 0 16px 4px;\n  padding: 6px 10px;\n  background: #ffe6df;\n  color: var(--fg-anti-red);\n  border-radius: 6px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.agent-edit__chat-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px 16px;\n  background: #fff;\n  border-top: 1px solid var(--fg-line);\n  flex-shrink: 0;\n}\n\n.agent-edit__chat-input-field {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 16px;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n  font-family: inherit;\n  font-size: 14px;\n  outline: none;\n  background: #fff;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__chat-input-field:disabled {\n  background: var(--fg-bg-card);\n  cursor: not-allowed;\n}\n\n.agent-edit__chat-send {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  color: var(--fg-button);\n  padding: 0;\n}\n\n.agent-edit__chat-send:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* 우측 캔버스 (workflow) */\n.agent-edit__canvas {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  background: #fafafa;\n  overflow: auto;\n}\n\n.agent-edit__canvas-zoom {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: var(--fg-text-basic);\n  color: #fff;\n  border-radius: 30px;\n  z-index: 5;\n}\n\n.agent-edit__canvas-zoom button {\n  background: transparent;\n  border: 0;\n  color: #fff;\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.agent-edit__canvas-zoom button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.agent-edit__canvas-zoom span {\n  font-size: 12px;\n}\n\n/* Workflow 노드 그리드 */\n.agent-edit__workflow {\n  padding: 80px 18px 30px;\n  display: flex;\n  justify-content: center;\n}\n\n/* Figma 캔버스(Group 1, 772×372) — 절대 좌표 + 연결선 */\n.agent-edit__canvas {\n  position: relative;\n  width: 772px;\n  height: 372px;\n  flex-shrink: 0;\n}\n\n/* Origin ↔ 위성 노드 연결선 */\n.agent-edit__line {\n  position: absolute;\n  height: 2px;\n  background: #86b6f3;\n  pointer-events: none;\n}\n\n.agent-edit__node {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid var(--fg-blue-lite, #86b6f3);\n  border-radius: 12px;\n  overflow: hidden;\n  font-size: 12px;\n}\n\n.agent-edit__node--highlight {\n  border: 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.13);\n}\n\n.agent-edit__node-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 12px;\n  background: var(--fg-bg-card);\n}\n\n.agent-edit__node--highlight .agent-edit__node-head {\n  padding: 4px 8px 8px 12px;\n  background: var(--fg-button);\n}\n\n.agent-edit__node-eyebrow {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-edit__node--highlight .agent-edit__node-eyebrow {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.agent-edit__node-action {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.agent-edit__node-action:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.agent-edit__node--normal .agent-edit__node-action:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.agent-edit__node-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px;\n}\n\n.agent-edit__node--highlight .agent-edit__node-body {\n  gap: 12px;\n  padding: 12px;\n}\n\n.agent-edit__node--highlight .agent-edit__node-section+.agent-edit__node-section {\n  border-top: 1px solid var(--fg-line);\n  padding-top: 12px;\n}\n\n.agent-edit__node-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.agent-edit__node-li {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 4px 2px 8px;\n  background: #fff;\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-li-icon {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-li-name {\n  flex-shrink: 0;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-li-sub {\n  flex-shrink: 0;\n  color: #bdbdbd;\n}\n\n.agent-edit__node-li-remove {\n  flex-shrink: 0;\n  margin-left: auto;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.agent-edit__node-li-remove:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-dot {\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n  background: var(--fg-text-gray);\n}\n\n.agent-edit__node-dot--green {\n  background: var(--fg-text-publishing);\n}\n\n.agent-edit__node-dot--gray {\n  background: #c2c2c2;\n}\n\n.agent-edit__node-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.agent-edit__node-label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: var(--fg-text-gray);\n}\n\n.agent-edit__node-text {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__node-box {\n  height: 68px;\n  padding: 8px;\n  background: #f8f8f8;\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.agent-edit__node-text-legacy {\n  margin: 0;\n  padding: 4px 6px;\n  background: var(--fg-bg-card);\n  border-radius: 4px;\n  font-size: 11px;\n  color: var(--fg-text-basic);\n  font-family: ui-monospace, 'SF Mono', Consolas, monospace;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Folder view */\n.agent-edit__folder {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  background: #fafafa;\n}\n\n.agent-edit__folder-tree {\n  width: 200px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 16px 12px;\n  background: #fff;\n  border-right: 1px solid var(--fg-line);\n}\n\n.agent-edit__folder-item {\n  padding: 8px 10px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__folder-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.agent-edit__folder-item--active {\n  background: var(--fg-bg-mychat);\n  color: var(--fg-button-hover);\n  font-weight: 600;\n}\n\n.agent-edit__folder-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.agent-edit__folder-content-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.agent-edit__folder-tabs {\n  display: flex;\n  gap: 4px;\n}\n\n.agent-edit__folder-tab {\n  padding: 6px 12px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 16px;\n  font-family: inherit;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.agent-edit__folder-tab--active {\n  background: var(--fg-bg-mychat);\n  border-color: var(--fg-button-hover);\n  color: var(--fg-button-hover);\n  font-weight: 600;\n}\n\n.agent-edit__folder-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 32px;\n}\n\n.agent-edit__folder-empty {\n  text-align: center;\n  color: var(--fg-text-gray);\n  padding: 40px;\n}\n\n@media (max-width: 1280px) {\n  .agent-edit__chat {\n    max-width: 480px;\n  }\n}\n\n/* ========================================================================\n   AgentChat — 에이전트 대화 + Workflow/Folder 패널 토글\n   ======================================================================== */\n\n.agent-chat__main {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 52px);\n  overflow: hidden;\n}\n\n.agent-chat__body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  overflow: hidden;\n  background: #fff;\n}\n\n.agent-chat__main-area {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 채팅 스크롤 */\n.agent-chat__scroller {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px 24px 16px;\n}\n\n.agent-chat__messages {\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.agent-chat__empty {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agent-chat__empty-text {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n/* 점 3개 펄스 (AgentCreate 입력 분석 상태 표시 등에서 사용) */\n.agent-chat__loading-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.agent-chat__loading-dots span {\n  width: 5px;\n  height: 5px;\n  background: var(--fg-text-gray);\n  border-radius: 50%;\n  opacity: 0.4;\n  animation: agent-chat-dot 1.2s infinite ease-in-out;\n}\n\n.agent-chat__loading-dots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.agent-chat__loading-dots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes agent-chat-dot {\n\n  0%,\n  80%,\n  100% {\n    opacity: 0.25;\n    transform: translateY(0);\n  }\n\n  40% {\n    opacity: 1;\n    transform: translateY(-2px);\n  }\n}\n\n.agent-chat__body--with-panel .agent-chat__messages {\n  max-width: none;\n}\n\n/* 입력 */\n.agent-chat__input-area {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 16px 24px 20px;\n  background: #fff;\n  border-top: 1px solid var(--fg-line);\n}\n\n.agent-chat__input {\n  flex: 1;\n  min-width: 0;\n  padding: 12px 20px;\n  border: 1px solid var(--fg-line);\n  border-radius: 22px;\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 22px;\n  outline: none;\n  background: #fff;\n  color: var(--fg-text-basic);\n  resize: none;\n  overflow-y: hidden;\n  max-height: 160px;\n  box-sizing: border-box;\n}\n\n.agent-chat__input:focus {\n  border-color: var(--fg-button);\n}\n\n.agent-chat__send {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  color: var(--fg-button);\n  padding: 0;\n}\n\n.agent-chat__send:hover {\n  color: var(--fg-button-hover);\n}\n\n/* ────────── 어시스턴트 인라인 카드 (clarify / modify_approval / oauth / tool-approval) ────────── */\n.agent-chat__assistant-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agent-chat__card {\n  align-self: stretch;\n  width: 100%;\n  max-width: 100%;\n  margin-left: 0;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 14px;\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.04));\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-sizing: border-box;\n}\n\n.agent-chat__card--answered {\n  opacity: 0.7;\n  background: var(--fg-bg-card, #f5f5f7);\n}\n\n.agent-chat__card-eyebrow {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--fg-text-gray);\n}\n\n/* ── Clarify (G-check 선택지) ── */\n.agent-chat__card-options {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.agent-chat__card-option-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast, 0.15s ease);\n}\n\n.agent-chat__card-option-btn:hover:not(:disabled) {\n  background: var(--fg-bg-liteblue);\n  border-color: var(--fg-button-hover);\n}\n\n.agent-chat__card-option-btn:disabled {\n  cursor: not-allowed;\n  background: var(--fg-bg-card, #f5f5f7);\n}\n\n.agent-chat__card-option-key {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--fg-bg-liteblue);\n  color: var(--fg-button);\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.agent-chat__card-option-label {\n  flex: 1;\n}\n\n/* ── Action list (modify / tool approval 공용) ── */\n.agent-chat__card-action-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.agent-chat__card-action {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  background: var(--fg-bg-card, #f5f5f7);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n}\n\n.agent-chat__card-action-tag {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-chat__card-action-tag--done {\n  background: #e8f7ee;\n  border-color: #b9e2c8;\n  color: #1a7d3c;\n}\n\n.agent-chat__card-action-text {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-chat__card-action-list--applied {\n  margin-bottom: 2px;\n}\n\n/* ── Action buttons (승인/거절/연결) ── */\n.agent-chat__card-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.agent-chat__card-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  background: #fff;\n  color: var(--fg-text-basic);\n  transition: var(--transition-fast, 0.15s ease);\n}\n\n.agent-chat__card-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.agent-chat__card-btn--primary {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n\n.agent-chat__card-btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n}\n\n.agent-chat__card-btn--ghost:hover:not(:disabled) {\n  background: var(--fg-bg-card, #f5f5f7);\n}\n\n/* ── OAuth 카드 ── */\n.agent-chat__card-oauth-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agent-chat__card-oauth-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  padding: 4px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agent-chat__card-oauth-icon--fallback {\n  color: var(--fg-text-gray);\n}\n\n.agent-chat__card-oauth-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.agent-chat__card-oauth-name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-chat__card-oauth-desc {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.agent-chat__card-oauth-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.agent-chat__card-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  background: var(--fg-bg-liteblue);\n  color: var(--fg-button);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: lowercase;\n}\n\n/* ── Note 카드 (notion picker / 미지원 / fallback paused) ── */\n.agent-chat__card--note {\n  background: var(--fg-bg-warm, #fff8ec);\n  border-color: var(--warning-border, #f0d089);\n}\n\n.agent-chat__card-text {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.agent-chat__card-note {\n  margin: 0;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px dashed var(--warning-border, #f0d089);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  line-height: 1.5;\n}\n\n/* ── 노션 페이지 picker 카드 modifier (안내 카드와 톤 분리) ── */\n.agent-chat__card--picker {\n  background: #fff;\n  border-color: var(--fg-line);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   노션 페이지 picker 모달 (paused / notion_page_picker)\n   skill-modal__* 패턴과 동일한 디자인 토큰(--fg-*) 체계로 재작성.\n   ═══════════════════════════════════════════════════════════════════════════ */\n.agent-notion-picker__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 24px;\n  animation: agentNotionPickerFade 0.18s ease-out;\n}\n\n@keyframes agentNotionPickerFade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.agent-notion-picker {\n  width: 100%;\n  max-width: 520px;\n  /* 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */\n  height: calc(100vh - 120px);\n  max-height: calc(100vh - 120px);\n  min-height: 480px;\n  background: #fff;\n  color: var(--fg-text-basic, #111827);\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-size: 14px;\n  animation: agentNotionPickerPop 160ms ease-out;\n}\n\n@keyframes agentNotionPickerPop {\n  from {\n    transform: translateY(8px) scale(0.98);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.agent-notion-picker__bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--fg-line, #e5e7eb);\n}\n\n.agent-notion-picker__brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #111827);\n}\n\n.agent-notion-picker__logo {\n  width: 22px;\n  height: 22px;\n  background: var(--fg-text-basic, #111827);\n  color: #fff;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: -0.5px;\n}\n\n.agent-notion-picker__title-block {\n  padding: 20px 24px 12px;\n}\n\n.agent-notion-picker__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #111827);\n  letter-spacing: -0.2px;\n  line-height: 1.4;\n}\n\n.agent-notion-picker__search-block {\n  padding: 0 24px 12px;\n}\n\n.agent-notion-picker__search {\n  position: relative;\n}\n\n.agent-notion-picker__search svg {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.agent-notion-picker__search input {\n  width: 100%;\n  padding: 10px 12px 10px 34px;\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  color: var(--fg-text-basic, #111827);\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.agent-notion-picker__search input:focus {\n  border-color: var(--fg-button, #978cca);\n  box-shadow: var(--focus-ring, 0 0 0 2px var(--primary-200, #ddd6fe));\n}\n\n.agent-notion-picker__search input::placeholder {\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.agent-notion-picker__banner {\n  margin: 0 24px 10px;\n  padding: 9px 12px;\n  background: var(--fg-bg-warning, #fff7ed);\n  color: var(--warning-text, #92400e);\n  border: 1px solid var(--warning-border, #fcd34d);\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.agent-notion-picker__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 16px 12px;\n  min-height: 0;\n}\n\n.agent-notion-picker__body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.agent-notion-picker__body::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 3px;\n}\n\n.agent-notion-picker__body::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.32);\n}\n\n.agent-notion-picker__body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.agent-notion-picker__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.agent-notion-picker__item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  margin: 2px 0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.12s;\n  color: var(--fg-text-basic, #111827);\n}\n\n.agent-notion-picker__item:hover {\n  background: var(--fg-bg-litepp, #e8eaf5);\n}\n\n.agent-notion-picker__item--selected {\n  background: var(--fg-bg-step-active, #f3f4ff);\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.agent-notion-picker__item-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: var(--fg-text-gray, #6b7280);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agent-notion-picker__item--selected .agent-notion-picker__item-icon {\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.agent-notion-picker__item-icon svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.agent-notion-picker__item-title {\n  flex: 1;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-notion-picker__item--selected .agent-notion-picker__item-title {\n  font-weight: 600;\n}\n\n.agent-notion-picker__item-check {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.agent-notion-picker__state {\n  padding: 44px 24px 36px;\n  text-align: center;\n}\n\n.agent-notion-picker__state-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #111827);\n  margin-bottom: 8px;\n}\n\n.agent-notion-picker__state-desc {\n  font-size: 13px;\n  color: var(--fg-text-gray, #6b7280);\n  margin-bottom: 22px;\n  line-height: 1.6;\n}\n\n.agent-notion-picker__state-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  background: var(--fg-button, #978cca);\n  color: #fff;\n  border-radius: 8px;\n  border: none;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.agent-notion-picker__state-btn:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.agent-notion-picker__skel-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n}\n\n.agent-notion-picker__skel {\n  background: linear-gradient(90deg,\n      var(--fg-bg-content, #f2f2f2),\n      var(--fg-line, #e5e7eb),\n      var(--fg-bg-content, #f2f2f2));\n  background-size: 200% 100%;\n  animation: agentNotionPickerShimmer 1.6s infinite linear;\n  border-radius: 4px;\n}\n\n@keyframes agentNotionPickerShimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.agent-notion-picker__skel--icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.agent-notion-picker__skel--line {\n  height: 11px;\n  width: 55%;\n}\n\n.agent-notion-picker__footer {\n  padding: 12px 24px 16px;\n  border-top: 1px solid var(--fg-line, #e5e7eb);\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.agent-notion-picker__btn {\n  height: 36px;\n  padding: 0 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.agent-notion-picker__btn--cancel {\n  background: transparent;\n  color: var(--fg-text-basic, #111827);\n  border-color: var(--fg-line, #e5e7eb);\n}\n\n.agent-notion-picker__btn--cancel:hover {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.agent-notion-picker__btn--primary {\n  background: var(--fg-button, #978cca);\n  color: #fff;\n}\n\n.agent-notion-picker__btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.agent-notion-picker__btn--primary:disabled {\n  background: var(--fg-line, #e5e7eb);\n  color: var(--fg-text-gray, #6b7280);\n  cursor: not-allowed;\n}\n\n/* 패널 열린 상태 — Figma 비율 (chat 728 : panel 808 ≈ 47:53) */\n.agent-chat__body--with-panel .agent-chat__main-area {\n  flex: 728 0 0;\n  min-width: 380px;\n  border-right: 1px solid var(--fg-line);\n}\n\n.agent-chat__body--with-panel .agent-chat__messages {\n  max-width: 100%;\n}\n\n/* 우측 슬라이드 패널 */\n.agent-chat__panel {\n  position: relative;\n  flex: 808 0 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fafafa;\n  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.04);\n  animation: agentChatPanelIn 0.18s ease-out;\n}\n\n@keyframes agentChatPanelIn {\n  from {\n    transform: translateX(20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.agent-chat__panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: var(--fg-bg-toolbar);\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n}\n\n.agent-chat__panel-head--folder {\n  background: #fff;\n}\n\n.agent-chat__panel-zoom {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: var(--fg-text-basic);\n  color: #fff;\n  border-radius: 30px;\n}\n\n.agent-chat__panel-zoom button {\n  background: transparent;\n  border: 0;\n  color: #fff;\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.agent-chat__panel-zoom button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.agent-chat__panel-zoom span {\n  font-size: 12px;\n}\n\n.agent-chat__panel-close {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.agent-chat__panel-close:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.agent-chat__panel-body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.agent-chat__panel-body--folder {\n  display: flex;\n  overflow: hidden;\n  background: #fff;\n}\n\n.agent-chat__panel-body--folder .agent-edit__folder-tree {\n  width: 140px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--fg-line);\n  background: #fff;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.agent-chat__panel-body--folder .agent-edit__folder-tree .agent-edit__folder-item {\n  font-size: 13px;\n  padding: 6px 8px;\n}\n\n.agent-chat__panel-body--folder .agent-edit__folder-body {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n  padding: 20px 28px;\n  background: #fff;\n}\n\n/* 파일 트리 아이템 — 아이콘 + 이름 가로 정렬 */\n.agent-edit__folder-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__folder-item svg {\n  flex-shrink: 0;\n  color: var(--fg-text-gray);\n}\n\n.agent-edit__folder-item--active svg {\n  color: var(--fg-button-hover);\n}\n\n/* 우측 콘텐츠 래퍼 (헤더 + 본문) */\n.agent-chat__panel-body--folder .agent-edit__folder-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.agent-chat__panel-body--folder .agent-edit__folder-content-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--fg-line);\n  background: var(--fg-bg-card, #fafafa);\n}\n\n.agent-edit__folder-content-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__folder-content-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* 파일명 (헤더 좌측) */\n.agent-edit__folder-filename {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* 우측 헤더 액션: Read-only 뱃지 / 저장 */\n.agent-edit__folder-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  padding: 4px 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.agent-edit__folder-save {\n  background: var(--fg-button);\n  border: 1px solid var(--fg-button);\n  color: #fff;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__folder-save:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n}\n\n.agent-edit__folder-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* AGENTS.md Source 모드 — 마크다운 툴바 + 텍스트에어리어 */\n.agent-edit__folder-source {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: -20px -28px;\n}\n\n.agent-edit__folder-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 8px 16px;\n  background: var(--fg-bg-card, #fafafa);\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.agent-edit__folder-toolbar button {\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__folder-toolbar button:hover {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.agent-edit__folder-toolbar-sep {\n  width: 1px;\n  height: 18px;\n  background: var(--fg-line);\n  margin: 0 4px;\n}\n\n.agent-edit__folder-editor {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  resize: none;\n  padding: 16px 20px;\n  background: #fff;\n  border: 0;\n  outline: none;\n  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;\n  font-size: 13px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__folder-editor--full {\n  height: 100%;\n  margin: -20px -28px;\n  padding: 16px 24px;\n}\n\n/* config.json 코드 블록 */\n.agent-edit__folder-code {\n  margin: 0;\n  padding: 16px 20px;\n  background: var(--fg-bg-card, #fafafa);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;\n  font-size: 12.5px;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-x: auto;\n}\n\n/* =====================================================\n   Workflow 패널 — 캔버스 (Figma 2065:14802)\n   - 패널 전체가 다크 캔버스. 노드는 절대 좌표 배치.\n   - 점선 연결: origin ↔ 위성 노드\n   ===================================================== */\n.agent-chat__panel--workflow {\n  background: var(--fg-bg-dark);\n  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.2);\n}\n\n.workflow-canvas {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  /* background: var(--fg-bg-dark); */\n  background: #fbfbfb;\n  cursor: grab;\n  user-select: none;\n}\n\n.workflow-canvas--panning,\n.workflow-canvas--panning .workflow-canvas__inner {\n  cursor: grabbing;\n}\n\n/* 줌/맞춤/닫기 컨트롤 — 호버 시 표시 (Figma 2065:14785) */\n.workflow-canvas__toolbar {\n  position: absolute;\n  top: 16px;\n  left: 0;\n  right: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.18s ease;\n}\n\n.workflow-canvas:hover .workflow-canvas__toolbar,\n.workflow-canvas:focus-within .workflow-canvas__toolbar {\n  opacity: 1;\n}\n\n.workflow-canvas__toolbar-pill {\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 6px;\n  background: var(--fg-text-basic);\n  border-radius: 30px;\n  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.29));\n}\n\n.workflow-canvas__toolbar-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 30px;\n  color: #fff;\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.workflow-canvas__toolbar-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.workflow-canvas__toolbar-text {\n  padding: 0 2px;\n  font-size: 12px;\n  color: #fff;\n  user-select: none;\n}\n\n.workflow-canvas__inner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 800px;\n  height: 520px;\n  margin: 0;\n  transform-origin: 0 0;\n  will-change: transform;\n}\n\n/* 점선 연결선 (SVG bezier) — origin ↔ 위성 박스 */\n.workflow-canvas__svg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  overflow: visible;\n  z-index: 0;\n}\n\n.workflow-canvas__svg-path {\n  fill: none;\n  stroke: var(--fg-blue-lite);\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-dasharray: 6 5;\n}\n\n/* legacy span 점선 — 신규 SVG 로 교체됐지만 다른 곳에서 쓸 수 있어 유지 */\n.workflow-canvas__line {\n  position: absolute;\n  height: 0;\n  border-top: 2px dashed var(--fg-blue-lite);\n  pointer-events: none;\n}\n\n/* 노드 박스 헤더 — 드래그 핸들 */\n.workflow-node__header--draggable {\n  cursor: grab;\n  user-select: none;\n}\n\n.workflow-node__header--draggable:active {\n  cursor: grabbing;\n}\n\n/* ── 공통 노드 ── */\n.workflow-node {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  font-family: var(--font-sans);\n}\n\n.workflow-node__icon-btn {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.workflow-node__icon-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.workflow-node__icon-btn--on-purple {\n  color: #fff;\n}\n\n.workflow-node__icon-btn--on-purple:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n/* ── origin 노드 (메인 에이전트) ── */\n.workflow-node--origin {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.13);\n  z-index: 2;\n}\n\n.workflow-node__header--origin {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 14px 14px 18px;\n  background: var(--fg-button);\n}\n\n.workflow-node__title {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.workflow-node__body {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 20px;\n}\n\n.workflow-node__section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.workflow-node__section+.workflow-node__section {\n  padding-top: 12px;\n  border-top: 1px solid var(--fg-line);\n}\n\n.workflow-node__label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.15;\n  color: var(--fg-text-gray);\n  letter-spacing: 0.02em;\n}\n\n.workflow-node__text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--fg-text-basic);\n  word-break: break-word;\n}\n\n.workflow-node__box {\n  height: 400px;\n  padding: 14px;\n  background: var(--fg-bg-content);\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--fg-text-gray);\n  overflow-x: hidden;\n  overflow-y: auto;\n  word-break: break-word;\n}\n\n/* ── side 노드 (FEW-SHOT EXAMPLES) ── */\n.workflow-node--side {\n  border: 1px solid var(--fg-blue-lite);\n  min-height: 160px;\n  max-height: 210px;\n}\n\n.workflow-node__empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 14px;\n  min-height: 110px;\n}\n\n.workflow-node__empty-text {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n.workflow-node__header--side {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px 8px 16px;\n  background: var(--fg-bg-card);\n}\n\n.workflow-node__header--side .workflow-node__icon-btn {\n  width: 26px;\n  height: 26px;\n}\n\n.workflow-node__eyebrow {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.15;\n  color: var(--fg-text-gray);\n  letter-spacing: 0.02em;\n}\n\n.workflow-node__list {\n  list-style: none;\n  margin: 0;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.workflow-node__list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.workflow-node__list::-webkit-scrollbar-thumb {\n  background: var(--fg-line);\n  border-radius: 3px;\n}\n\n.workflow-node__list::-webkit-scrollbar-thumb:hover {\n  background: var(--fg-text-menu);\n}\n\n.workflow-node__list-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 6px 6px 10px;\n  background: #fff;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.workflow-node__list-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.workflow-node__dot {\n  flex-shrink: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--fg-line);\n}\n\n.workflow-node__dot--green {\n  background: var(--fg-class-green);\n}\n\n.workflow-node__list-icon {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-basic);\n}\n\n.workflow-node__list-favicon {\n  display: block;\n  border-radius: 4px;\n}\n\n.workflow-node__list-text {\n  flex: 1;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.workflow-node__list-name {\n  color: var(--fg-text-basic);\n}\n\n.workflow-node__list-sub {\n  color: var(--fg-text-menu);\n}\n\n.workflow-node__list-remove {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.workflow-node__list-remove:hover {\n  color: var(--fg-anti-red);\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* ── 연결 provider 묶음(connected_tool_packs) ── */\n.workflow-node__pack {\n  display: flex;\n  flex-direction: column;\n}\n\n.workflow-node__pack-head {\n  width: 100%;\n}\n\n.workflow-node__pack-caret {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-menu);\n  transition: transform var(--transition-fast), color var(--transition-fast);\n}\n\n.workflow-node__pack-head:hover .workflow-node__pack-caret {\n  color: var(--fg-text-basic);\n}\n\n.workflow-node__pack-caret.is-open {\n  transform: rotate(90deg);\n}\n\n/* 묶음 개수 배지 — 다크 네이비 pill */\n.workflow-node__count-badge {\n  flex-shrink: 0;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  display: inline-grid;\n  place-items: center;\n  background: var(--fg-bg-dark);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  border-radius: 9px;\n}\n\n/* 펼친 멤버 도구 — 들여쓰기 + 약하게 */\n.workflow-node__pack-members {\n  list-style: none;\n  margin: 2px 0 2px 14px;\n  padding: 0 0 0 8px;\n  border-left: 1px solid var(--fg-line);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.workflow-node__pack-member {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 6px;\n  border-radius: 6px;\n}\n\n.workflow-node__pack-member .workflow-node__list-icon {\n  color: var(--fg-text-menu);\n}\n\n.workflow-node__pack-member .workflow-node__list-text {\n  font-size: 12px;\n}\n\n.workflow-node__pack-member .workflow-node__list-name {\n  color: var(--fg-text-gray);\n}\n\n\n/* =====================================================\n   스킬 상세 모달 (SkillDetailModal)\n   ===================================================== */\n.skill-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: skill-modal-fade-in 120ms ease-out;\n}\n\n@keyframes skill-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.skill-modal__dialog {\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n  animation: skill-modal-pop-in 160ms ease-out;\n}\n\n@keyframes skill-modal-pop-in {\n  from {\n    transform: translateY(8px) scale(0.98);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* head */\n.skill-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--fg-line, #e5e7eb);\n}\n\n.skill-modal__head-text {\n  min-width: 0;\n}\n\n.skill-modal__eyebrow {\n  margin: 0 0 4px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--fg-text-gray, #6b7280);\n  text-transform: uppercase;\n}\n\n.skill-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic, #111827);\n  word-break: break-word;\n}\n\n.skill-modal__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray, #6b7280);\n  cursor: pointer;\n  transition: var(--transition-fast, background-color 120ms);\n}\n\n.skill-modal__close:hover {\n  background: rgba(15, 23, 42, 0.06);\n  color: var(--fg-text-basic, #111827);\n}\n\n/* body */\n.skill-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.skill-modal__body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.skill-modal__body::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 3px;\n}\n\n.skill-modal__body::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.32);\n}\n\n.skill-modal__body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.skill-modal__section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.skill-modal__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray, #6b7280);\n  letter-spacing: 0.02em;\n}\n\n.skill-modal__text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic, #111827);\n  white-space: pre-wrap;\n}\n\n.skill-modal__value {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #111827);\n}\n\n.skill-modal__meta-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 24px;\n}\n\n.skill-modal__meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.skill-modal__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.skill-modal__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  background: var(--fg-bg-mychat, #f3f4f6);\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 999px;\n  font-size: 12px;\n  color: var(--fg-text-basic, #111827);\n}\n\n.skill-modal__markdown {\n  padding: 12px 14px;\n  background: var(--fg-bg-mychat, #f9fafb);\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic, #111827);\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.skill-modal__markdown p {\n  margin: 0 0 8px;\n}\n\n.skill-modal__markdown p:last-child {\n  margin-bottom: 0;\n}\n\n.skill-modal__markdown h1,\n.skill-modal__markdown h2,\n.skill-modal__markdown h3 {\n  margin: 12px 0 6px;\n  font-weight: 600;\n}\n\n.skill-modal__markdown ul,\n.skill-modal__markdown ol {\n  padding-left: 20px;\n  margin: 0 0 8px;\n}\n\n.skill-modal__markdown code {\n  padding: 2px 6px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.skill-modal__markdown pre {\n  padding: 10px 12px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.skill-modal__markdown pre code {\n  padding: 0;\n  background: transparent;\n}\n\n.skill-modal__timestamps {\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  font-size: 12px;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.skill-modal__timestamp {\n  white-space: nowrap;\n}\n\n.skill-modal__empty {\n  margin: 0;\n  text-align: center;\n  font-size: 14px;\n  color: var(--fg-text-gray, #6b7280);\n  padding: 24px 0;\n}\n\n/* foot */\n.skill-modal__foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px 16px;\n  border-top: 1px solid var(--fg-line, #e5e7eb);\n}\n\n.skill-modal__foot-spacer {\n  flex: 1;\n}\n\n.skill-modal__btn {\n  height: 36px;\n  padding: 0 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition-fast, all 120ms);\n  border: 1px solid transparent;\n}\n\n.skill-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.skill-modal__btn--primary {\n  background: var(--fg-button, #7c3aed);\n  color: #fff;\n}\n\n.skill-modal__btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover, #6d28d9);\n}\n\n.skill-modal__btn--ghost {\n  background: transparent;\n  color: var(--fg-text-basic, #111827);\n  border-color: var(--fg-line, #e5e7eb);\n}\n\n.skill-modal__btn--ghost:hover:not(:disabled) {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.skill-modal__btn--danger {\n  background: transparent;\n  color: var(--fg-anti-red, #dc2626);\n  border-color: rgba(220, 38, 38, 0.32);\n}\n\n.skill-modal__btn--danger:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.08);\n}\n\n\n/* 모드 탭 (생성 모달의 AI/직접 토글) */\n.skill-modal__tabs {\n  display: inline-flex;\n  background: var(--fg-bg-litepp, #f3f4f6);\n  padding: 4px;\n  border-radius: 10px;\n  gap: 4px;\n}\n\n.skill-modal__tab {\n  padding: 6px 14px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray, #6b7280);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.skill-modal__tab--active {\n  background: #fff;\n  color: var(--fg-button, #7c3aed);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.skill-modal__tab:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* skill.md 라벨 + AI 보조 액션 행 */\n.skill-modal__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.skill-modal__ai-actions {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.skill-modal__ai-btn {\n  height: 28px;\n  padding: 0 10px;\n  background: var(--fg-bg-litepp, #f3f4f6);\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-button-hover, #6d28d9);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.skill-modal__ai-btn:hover:not(:disabled) {\n  background: #fff;\n  border-color: var(--fg-button, #7c3aed);\n  color: var(--fg-button, #7c3aed);\n}\n\n.skill-modal__ai-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 생성 모달 미리보기 토글 */\n.skill-modal__preview-toggle {\n  margin-top: 8px;\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n\n.skill-modal__preview-toggle>summary {\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #111827);\n  user-select: none;\n}\n\n.skill-modal__preview-toggle .skill-modal__markdown {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px dashed var(--fg-line, #e5e7eb);\n}\n\n/* 편집 모드 폼 컨트롤 */\n.skill-modal__input,\n.skill-modal__textarea {\n  width: 100%;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic, #111827);\n  font-family: inherit;\n  transition: var(--transition-fast, border-color 120ms);\n  box-sizing: border-box;\n}\n\n.skill-modal__textarea {\n  resize: vertical;\n  min-height: 64px;\n}\n\n.skill-modal__textarea--code {\n  font-family: 'JetBrains Mono', 'Consolas', 'Menlo', monospace;\n  font-size: 13px;\n  line-height: 20px;\n  min-height: 200px;\n}\n\n.skill-modal__input:focus,\n.skill-modal__textarea:focus {\n  outline: none;\n  border-color: var(--fg-button, #7c3aed);\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);\n}\n\n.skill-modal__hint {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--fg-text-gray, #9ca3af);\n  margin-left: 4px;\n}\n\n.skill-modal__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #111827);\n  cursor: pointer;\n}\n\n.skill-modal__toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n/* =====================================================\n   스킬 생성 모달 (SkillCreateModal) — 피그마 2026-04 시안\n   ===================================================== */\n.skill-modal__dialog--create {\n  max-width: 743px;\n  border-radius: 16px;\n  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);\n}\n\n.skill-modal__dialog--create .skill-modal__head {\n  align-items: center;\n  gap: 4px;\n  padding: 20px 20px 12px;\n  border-bottom: 1px solid var(--fg-line, #dbdbdb);\n}\n\n.skill-modal__dialog--create .skill-modal__title {\n  flex: 1 0 0;\n  min-width: 0;\n  font-family: inherit;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.skill-modal__dialog--create .skill-modal__close {\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  border-radius: 8px;\n}\n\n.skill-modal__dialog--create .skill-modal__body {\n  padding: 20px;\n  gap: 20px;\n}\n\n.skill-modal__dialog--create .skill-modal__section {\n  gap: 8px;\n}\n\n.skill-modal__lead {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: normal;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n/* 탭 (언더라인) */\n.skill-modal__dialog--create .skill-modal__tabs {\n  display: flex;\n  width: 100%;\n  padding: 0;\n  gap: 4px;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 0;\n}\n\n.skill-modal__dialog--create .skill-modal__tab {\n  flex: 1 0 0;\n  min-width: 0;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  border-radius: 0;\n  box-shadow: none;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  text-align: center;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  transition: color 120ms ease, border-color 120ms ease;\n}\n\n.skill-modal__dialog--create .skill-modal__tab:hover:not(:disabled) {\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.skill-modal__dialog--create .skill-modal__tab--active {\n  background: transparent;\n  border-bottom-color: var(--fg-text-basic, #3b3b3b);\n  color: var(--fg-text-basic, #3b3b3b);\n  box-shadow: none;\n}\n\n/* 라벨 (14px Bold) */\n.skill-modal__dialog--create .skill-modal__label {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.skill-modal__label-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.skill-modal__hint-block {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--fg-text-gray, #838383);\n}\n\n.skill-modal__sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* 입력 / 텍스트영역 */\n.skill-modal__dialog--create .skill-modal__input,\n.skill-modal__dialog--create .skill-modal__textarea {\n  width: 100%;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n  box-sizing: border-box;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.skill-modal__dialog--create .skill-modal__input::placeholder,\n.skill-modal__dialog--create .skill-modal__textarea::placeholder {\n  color: var(--fg-text-gray, #838383);\n}\n\n.skill-modal__dialog--create .skill-modal__textarea {\n  min-height: 112px;\n  resize: vertical;\n}\n\n.skill-modal__dialog--create .skill-modal__textarea--code {\n  min-height: 160px;\n  font-family: 'JetBrains Mono', 'Consolas', 'Menlo', monospace;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.skill-modal__dialog--create .skill-modal__input:focus,\n.skill-modal__dialog--create .skill-modal__textarea:focus {\n  outline: none;\n  border-color: var(--fg-button, #978cca);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.18);\n}\n\n/* \"다시 생성\" 툴바형 버튼 */\n.skill-modal__regen {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100%;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp, #e8eaf5);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-button-hover, #7362c2);\n  cursor: pointer;\n  transition: background-color 120ms ease;\n}\n\n.skill-modal__regen:hover:not(:disabled) {\n  background: var(--fg-bg-litepp-hover, #cbd1ef);\n}\n\n.skill-modal__regen:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 푸터 — 중앙 정렬 (저장/취소) */\n.skill-modal__foot--centered {\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 20px 20px;\n  border-top: 0;\n}\n\n.skill-modal__dialog--create .skill-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  height: auto;\n  padding: 6px 12px;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 120ms ease, opacity 120ms ease;\n}\n\n.skill-modal__dialog--create .skill-modal__btn--primary {\n  background: var(--fg-button, #978cca);\n  color: #fff;\n  border: 0;\n}\n\n.skill-modal__dialog--create .skill-modal__btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.skill-modal__btn--cancel {\n  background: var(--fg-text-gray, #838383);\n  color: #fff;\n  border: 0;\n}\n\n.skill-modal__btn--cancel:hover:not(:disabled) {\n  background: #6b6b6b;\n}\n\n\n/* =====================================================\n   Workflow + 버튼 모달 (WorkflowModals)\n   라이트 테마 — SkillDetailModal 과 같은 톤\n   ===================================================== */\n.workflow-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: skill-modal-fade-in 120ms ease-out;\n}\n\n.workflow-modal__dialog {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n  animation: skill-modal-pop-in 160ms ease-out;\n}\n\n.workflow-modal__dialog--wide {\n  max-width: 1120px;\n}\n\n/* 검색 리스트형 모달 — 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */\n.workflow-modal__dialog--fixed-height {\n  height: calc(100vh - 64px);\n}\n\n.workflow-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.workflow-modal__head-text {\n  min-width: 0;\n}\n\n.workflow-modal__eyebrow {\n  margin: 0 0 4px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--fg-text-gray);\n}\n\n.workflow-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.workflow-modal__close:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.workflow-modal__footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 24px;\n  border-top: 1px solid var(--fg-line);\n  background: var(--fg-bg-card);\n}\n\n.workflow-modal__spacer {\n  flex: 1;\n}\n\n.workflow-modal__btn {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__btn--ghost {\n  background: #fff;\n  border-color: var(--fg-line);\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__btn--ghost:hover:not(:disabled) {\n  background: var(--fg-bg-card);\n}\n\n.workflow-modal__btn--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.workflow-modal__btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.workflow-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── [DRAFT] KB 모달 원본파일 리스트 (신규 UI 초안) ─── */\n.workflow-modal__origin-list {\n  margin-bottom: 16px;\n  padding: 12px 14px 10px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.workflow-modal__origin-list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.workflow-modal__origin-list-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__origin-list-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 20px;\n  padding: 0 7px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--fg-button);\n  background: color-mix(in srgb, var(--fg-button) 12%, transparent);\n  border-radius: 999px;\n}\n\n.workflow-modal__origin-list-all {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-button);\n  background: transparent;\n  border: 1px solid color-mix(in srgb, var(--fg-button) 40%, transparent);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__origin-list-all:hover {\n  background: color-mix(in srgb, var(--fg-button) 8%, transparent);\n}\n\n.workflow-modal__origin-list-items {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.workflow-modal__origin-list-item {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  font-family: inherit;\n  text-align: left;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__origin-list-item:hover {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-liteblue);\n}\n\n.workflow-modal__origin-list-item-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.workflow-modal__origin-list-item-footer {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px dashed var(--fg-line);\n}\n\n.workflow-modal__origin-list-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border-radius: 6px;\n}\n\n.workflow-modal__origin-list-item-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.workflow-modal__origin-list-item-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.workflow-modal__origin-list-item-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n.workflow-modal__origin-list-item-dot {\n  opacity: 0.5;\n}\n\n.workflow-modal__origin-list-item-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex: 1 1 0;\n  min-width: 0;\n  height: 32px;\n  padding: 0 10px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__origin-list-item-action-btn--import {\n  color: #fff;\n  background: var(--fg-button);\n  border: 1px solid var(--fg-button);\n}\n\n.workflow-modal__origin-list-item-action-btn--import:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n}\n\n.workflow-modal__origin-list-item-action-btn--download {\n  color: var(--fg-text-basic);\n  background: #fff;\n  border: 1px solid var(--fg-line);\n}\n\n.workflow-modal__origin-list-item-action-btn--download:hover:not(:disabled) {\n  color: var(--fg-button);\n  border-color: var(--fg-button);\n  background: var(--fg-bg-liteblue);\n}\n\n.workflow-modal__origin-list-item-action-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.workflow-modal__origin-list-hint {\n  margin: 10px 0 0;\n  padding-top: 8px;\n  font-size: 11px;\n  color: var(--fg-text-gray);\n  border-top: 1px dashed var(--fg-line);\n}\n\n/* ─── KB 모달 원본파일 다운로드 배너 ─── */\n.workflow-modal__origin-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n  padding: 10px 14px;\n  background: color-mix(in srgb, var(--fg-button) 8%, var(--fg-bg-card));\n  border: 1px solid color-mix(in srgb, var(--fg-button) 24%, transparent);\n  border-radius: 8px;\n}\n\n.workflow-modal__origin-banner-text {\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n}\n\n.workflow-modal__origin-banner-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-button);\n  background: #fff;\n  border: 1px solid color-mix(in srgb, var(--fg-button) 40%, transparent);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__origin-banner-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--fg-button) 10%, #fff);\n  border-color: var(--fg-button);\n}\n\n.workflow-modal__origin-banner-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.workflow-modal__origin-banner-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid color-mix(in srgb, var(--fg-button) 30%, transparent);\n  border-top-color: var(--fg-button);\n  border-radius: 50%;\n  animation: workflow-modal__origin-spin 0.8s linear infinite;\n}\n\n@keyframes workflow-modal__origin-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.workflow-modal__inline-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  user-select: none;\n}\n\n.workflow-modal__inline-toggle input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\n/* 검색 input */\n.workflow-modal__search {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n}\n\n.workflow-modal__search-input {\n  flex: 1;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-size: 13px;\n  background: transparent;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__search-input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n/* 카테고리 필터 칩 */\n.workflow-modal__cat-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 10px 0 4px;\n}\n\n.workflow-modal__cat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__cat-chip:hover:not(:disabled) {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.workflow-modal__cat-chip--active {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n\n.workflow-modal__cat-chip:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.workflow-modal__cat-chip-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 18px;\n  height: 16px;\n  padding: 0 5px;\n  background: var(--fg-bg-litepp);\n  color: var(--fg-text-gray);\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 999px;\n  line-height: 1;\n}\n\n.workflow-modal__cat-chip--active .workflow-modal__cat-chip-count {\n  background: rgba(255, 255, 255, 0.25);\n  color: #fff;\n}\n\n/* 멀티셀렉트 리스트 */\n.workflow-modal__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.workflow-modal__list-item {\n  display: flex;\n}\n\n.workflow-modal__list-btn {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__list-btn:hover {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-liteblue);\n}\n\n.workflow-modal__list-item--selected .workflow-modal__list-btn {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-liteblue);\n}\n\n.workflow-modal__check {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 4px;\n  margin-top: 1px;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__check--on {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n}\n\n.workflow-modal__list-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.workflow-modal__list-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  word-break: break-word;\n}\n\n.workflow-modal__list-desc {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.workflow-modal__empty {\n  padding: 20px 12px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n/* 폼 (스케줄 모달) */\n.workflow-modal__form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.workflow-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.workflow-modal__field-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__field-input {\n  padding: 9px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__field-input:focus {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px var(--fg-bg-liteblue);\n}\n\n.workflow-modal__field-hint {\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n/* 스케줄 모달 — 기존 스케줄 리스트 */\n.workflow-modal__schedule-existing {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.workflow-modal__list-btn--static {\n  cursor: default;\n}\n\n.workflow-modal__list-btn--static:hover {\n  border-color: var(--fg-line);\n  background: #fff;\n}\n\n.workflow-modal__schedule-del {\n  margin-left: 8px;\n  align-self: center;\n}\n\n/* 탭 (CHANNELS 모달) */\n.workflow-modal__tabs {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.workflow-modal__tab {\n  flex: 1;\n  padding: 8px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__tab:hover {\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__tab--active {\n  background: #fff;\n  color: var(--fg-text-basic);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n/* provider/channel row */\n.workflow-modal__provider-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.workflow-modal__provider-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.workflow-modal__provider-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n}\n\n.workflow-modal__provider-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.workflow-modal__provider-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__provider-meta {\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n/* iOS 스타일 토글 스위치 */\n.workflow-modal__switch {\n  position: relative;\n  flex-shrink: 0;\n  width: 40px;\n  height: 22px;\n  display: inline-block;\n}\n\n.workflow-modal__switch input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.workflow-modal__switch-thumb {\n  position: absolute;\n  inset: 0;\n  background: var(--fg-line);\n  border-radius: 30px;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__switch-thumb::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__switch input:checked+.workflow-modal__switch-thumb {\n  background: var(--fg-button);\n}\n\n.workflow-modal__switch input:checked+.workflow-modal__switch-thumb::after {\n  transform: translateX(18px);\n}\n\n.workflow-modal__switch input:disabled+.workflow-modal__switch-thumb {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── KB 모달 신규 레이아웃 — 공유 원본 접힘 / 검색+업로드 한 줄 / 선택됨 sticky 섹션 ─── */\n.workflow-modal__origin-list--collapsible {\n  padding: 10px 14px;\n}\n\n.workflow-modal__origin-list--collapsible .workflow-modal__origin-list-head {\n  margin-bottom: 0;\n}\n\n.workflow-modal__origin-list--collapsible.workflow-modal__origin-list--open {\n  padding-bottom: 12px;\n}\n\n.workflow-modal__origin-list--collapsible.workflow-modal__origin-list--open .workflow-modal__origin-list-head {\n  margin-bottom: 10px;\n}\n\n.workflow-modal__origin-list-title--btn {\n  padding: 2px 0;\n  font-family: inherit;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  color: var(--fg-text-basic);\n}\n\n.workflow-modal__origin-list-title--btn:hover {\n  color: var(--fg-button);\n}\n\n.workflow-modal__origin-list-chev {\n  color: var(--fg-text-gray);\n  transition: transform 0.18s ease, color 0.18s ease;\n}\n\n.workflow-modal__origin-list--open .workflow-modal__origin-list-chev {\n  transform: rotate(90deg);\n  color: var(--fg-button);\n}\n\n.workflow-modal__search-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.workflow-modal__search-row .workflow-modal__search {\n  flex: 1;\n}\n\n.workflow-modal__upload-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-button);\n  background: #fff;\n  border: 1px dashed color-mix(in srgb, var(--fg-button) 45%, transparent);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  white-space: nowrap;\n}\n\n.workflow-modal__upload-toggle:hover {\n  background: color-mix(in srgb, var(--fg-button) 8%, #fff);\n  border-color: var(--fg-button);\n}\n\n.workflow-modal__upload-toggle--active {\n  color: #fff;\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  border-style: solid;\n}\n\n.workflow-modal__section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.workflow-modal__section-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 2px;\n  background: #fff;\n}\n\n.workflow-modal__section-head--sticky {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 10px 2px 8px;\n  margin: -6px -2px 0;\n  border-bottom: 1px solid var(--fg-line);\n  box-shadow: 0 6px 8px -8px rgba(0, 0, 0, 0.18);\n}\n\n.workflow-modal__section-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--fg-text-gray);\n}\n\n.workflow-modal__section-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 22px;\n  height: 20px;\n  padding: 0 7px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--fg-button);\n  background: color-mix(in srgb, var(--fg-button) 12%, transparent);\n  border-radius: 999px;\n}\n\n.workflow-modal__section-clear {\n  margin-left: auto;\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.workflow-modal__section-clear:hover {\n  color: var(--fg-anti-red, #c5343a);\n  background: var(--fg-bg-card);\n}\n\n/* ─── Origin 노드 편집 — 우측 슬라이드 패널 ─── */\n.agent-edit__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  pointer-events: none;\n  background: transparent;\n  transition: background 0.25s ease;\n}\n\n.agent-edit__overlay--open {\n  pointer-events: auto;\n  background: rgba(0, 0, 0, 0.18);\n}\n\n.agent-edit__panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: min(760px, 92vw);\n  height: 100%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.12);\n  transform: translateX(100%);\n  transition: transform 0.28s ease;\n}\n\n.agent-edit__overlay--open .agent-edit__panel {\n  transform: translateX(0);\n}\n\n.agent-edit__panel-head {\n  flex-shrink: 0;\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid var(--fg-line);\n  background: var(--fg-bg-card, #fafafa);\n}\n\n.agent-edit__panel-head-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.agent-edit__panel-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__panel-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agent-edit__panel-save {\n  background: var(--fg-button);\n  border: 1px solid var(--fg-button);\n  color: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__panel-save:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n  border-color: var(--fg-button-hover);\n}\n\n.agent-edit__panel-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agent-edit__panel-close {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__panel-close:hover {\n  background: var(--fg-line);\n  color: var(--fg-text-basic);\n}\n\n.agent-edit__panel-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agent-edit__panel-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.agent-edit__panel-field>span {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n}\n\n.agent-edit__panel-field input,\n.agent-edit__panel-field select {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__panel-field input:focus,\n.agent-edit__panel-field select:focus {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);\n}\n\n/* 폴더 multi-select 필드 */\n.agent-edit__folder {\n  position: relative;\n}\n\n.agent-edit__folder-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  min-height: 36px;\n  padding: 4px 6px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  cursor: text;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__folder-chips:focus-within {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);\n}\n\n.agent-edit__folder-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  height: 24px;\n  padding: 0 4px 0 8px;\n  background: var(--fg-bg-mychat);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-button-hover);\n}\n\n.agent-edit__folder-chip-x {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  color: inherit;\n  cursor: pointer;\n}\n\n.agent-edit__folder-chip-x:hover {\n  background: rgba(86, 60, 240, 0.15);\n}\n\n.agent-edit__folder .agent-edit__folder-input {\n  flex: 1;\n  min-width: 100px;\n  width: auto;\n  height: 26px;\n  padding: 0 4px;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  outline: none;\n}\n\n.agent-edit__folder .agent-edit__folder-input:focus {\n  border: 0;\n  box-shadow: none;\n}\n\n.agent-edit__folder-suggest {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 10;\n  margin: 0;\n  padding: 4px;\n  list-style: none;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  box-shadow: var(--shadow-md);\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.agent-edit__folder-suggest-item {\n  display: block;\n  width: 100%;\n  padding: 6px 8px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  text-align: left;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.agent-edit__folder-suggest-item:hover {\n  background: var(--fg-bg-mychat);\n}\n\n.agent-edit__panel-body {\n  flex: 1;\n  min-height: 0;\n  padding: 16px 20px 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.agent-edit__panel-textarea {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  resize: none;\n  padding: 14px 16px;\n  background: var(--fg-bg-card, #fafafa);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  font-family: 'Fira Code', 'Consolas', 'Menlo', monospace;\n  font-size: 13px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.agent-edit__panel-textarea:focus {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);\n}\n\n/* ────────────────────────────────────────────────────────────\n * AgentExportModal — 발행(공유 링크) 관리 모달\n * ────────────────────────────────────────────────────────── */\n.agent-export__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: agent-export-fade 160ms ease-out;\n}\n\n@keyframes agent-export-fade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.agent-export__dialog {\n  width: 100%;\n  max-width: 640px;\n  max-height: min(80vh, 720px);\n  background: var(--fg-bg-card, #fff);\n  border-radius: 20px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18), 0 6px 12px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--font-sans);\n  animation: agent-export-slide 180ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes agent-export-slide {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.agent-export__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.agent-export__header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.agent-export__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.agent-export__subtitle {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--fg-text-gray);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-export__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-export__close:hover {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-basic);\n}\n\n.agent-export__body {\n  flex: 1;\n  min-height: 0;\n  padding: 16px 24px;\n  overflow-y: auto;\n}\n\n.agent-export__empty {\n  margin: 0;\n  padding: 48px 0;\n  text-align: center;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.agent-export__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.agent-export__item {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.agent-export__item:hover {\n  border-color: var(--fg-button);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);\n}\n\n.agent-export__item--inactive {\n  opacity: 0.7;\n  background: var(--fg-bg-content);\n}\n\n.agent-export__item-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.agent-export__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 999px;\n  letter-spacing: 0.02em;\n}\n\n.agent-export__badge--active {\n  color: #0a7c4d;\n  background: rgba(16, 185, 129, 0.12);\n}\n\n.agent-export__badge--inactive {\n  color: var(--fg-text-gray);\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.agent-export__meta {\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.agent-export__url-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.agent-export__url {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-export__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.agent-export__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-export__icon-btn:hover:not(:disabled) {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.agent-export__icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agent-export__icon-btn--danger {\n  color: var(--fg-anti-red);\n}\n\n.agent-export__icon-btn--danger:hover:not(:disabled) {\n  border-color: var(--fg-anti-red);\n  background: rgba(239, 68, 68, 0.06);\n  color: var(--fg-anti-red);\n}\n\n.agent-export__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 16px 24px 20px;\n  border-top: 1px solid var(--fg-line);\n}\n\n.agent-export__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 16px;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  border: 1px solid transparent;\n}\n\n.agent-export__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.agent-export__btn--secondary {\n  background: #fff;\n  border-color: var(--fg-line);\n  color: var(--fg-text-basic);\n}\n\n.agent-export__btn--secondary:hover:not(:disabled) {\n  border-color: var(--fg-text-gray);\n  background: var(--fg-bg-content);\n}\n\n.agent-export__btn--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.agent-export__btn--primary:hover:not(:disabled) {\n  filter: brightness(1.05);\n  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);\n}\n\n\n/* ── QR 코드 보기 모달 ── */\n.agent-export__overlay--qr {\n  z-index: 1010;\n  background: rgba(15, 23, 42, 0.65);\n}\n\n.agent-export__qr-dialog {\n  width: 100%;\n  max-width: 360px;\n  background: var(--fg-bg-card, #fff);\n  border-radius: 20px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.22), 0 6px 12px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--font-sans);\n  animation: agent-export-slide 180ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.agent-export__qr-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.agent-export__qr-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n}\n\n.agent-export__qr-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.agent-export__qr-image {\n  display: block;\n  width: 220px;\n  height: 220px;\n  object-fit: contain;\n  background: #fff;\n  padding: 8px;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.agent-export__qr-url {\n  margin: 0;\n  max-width: 100%;\n  font-size: 12px;\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\n  color: var(--fg-text-gray);\n  text-align: center;\n  word-break: break-all;\n}\n\n.agent-export__qr-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 20px 16px;\n  border-top: 1px solid var(--fg-line);\n}\n\n.agent-export__qr-footer .agent-export__btn--primary {\n  text-decoration: none;\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 에이전트 [1단계: 사이드바].\n   AgentSidebar(섹션 내비 + 대화 목록)는 AI채팅 패턴: 접힘 = 좌상단 플로팅 토글,\n   펼침 = 오버레이 드로어. 공유 셸을 쓰므로 .agent-page 로 스코프해 타 기능 영향 차단.\n   ※ 카드 그리드/채팅/2-pane 등 본문 반응형은 후속 단계에서 처리.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 카드 셸 여백 제거 — 폭 확보 */\n  .agent-page .prompt__layout {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림).\n     .agent__sidebar 의 max-height: calc(100vh - 52px)(데스크톱 sticky용)를 풀어\n     드로어가 화면 끝까지 차게 한다(하단 갭 제거). 100dvh 로 모바일 주소창까지 보정. */\n  .agent-page .prompt__sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 84vw;\n    max-width: 320px;\n    max-height: none;\n    height: 100vh;\n    height: 100dvh;\n    z-index: 200;\n    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);\n  }\n\n  /* 접힘 = AI채팅과 동일: 레일 대신 좌상단 플로팅 토글 버튼만, 본문은 풀폭 */\n  .agent-page .prompt__sidebar--collapsed {\n    position: fixed;\n    top: 60px;\n    left: 12px;\n    bottom: auto;\n    width: auto;\n    padding: 0;\n    gap: 0;\n    background: transparent;\n    box-shadow: none;\n    z-index: 60;\n  }\n\n  .agent-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {\n    display: none;\n  }\n\n  .agent-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    color: var(--fg-text-basic);\n  }\n\n  /* 본문 여백 + 플로팅 토글과 안 겹치게 제목 줄 들여쓰기 (prompt-intro 헤더 쓰는 화면) */\n  .agent-page .prompt__content {\n    padding: 16px 14px;\n    gap: 24px;\n  }\n\n  .agent-page .prompt-intro__heading {\n    min-height: 40px;\n    padding-left: 48px;\n  }\n\n  /* ── [2단계] AgentList / AgentSkills — 그리드 1열 + 공유 툴바 정리 ── */\n  .agent-page .agent-list__cards--grid,\n  .agent-page .agent-list__cards--list,\n  .agent-page .agent-skills__grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .agent-page .prompt-list__stats-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .agent-page .prompt-list__stats {\n    flex-wrap: wrap;\n    gap: 6px 8px;\n  }\n\n  .agent-page .prompt-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .agent-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  /* 그리드/리스트 토글은 1열 고정이라 무의미 → 숨김 */\n  .agent-page .prompt-list__view-toggle {\n    display: none;\n  }\n\n  /* ── [3단계] AgentChat — 대화 화면 ── */\n  /* 100dvh 로 모바일 주소창 보정 (헤더 ~48px) */\n  .agent-page .agent-chat__main {\n    height: calc(100dvh - 48px);\n  }\n\n  /* 툴바: 좌측에 플로팅 사이드바 토글 자리 확보 + 제목 말줄임 */\n  .agent-page .agent-edit__toolbar {\n    padding-left: 60px;\n  }\n\n  .agent-page .agent-edit__toolbar-title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  /* 우측 버튼(내보내기/Workflow/Folder)은 좁아서 텍스트 숨기고 아이콘만 */\n  .agent-page .agent-edit__tb-btn span {\n    display: none;\n  }\n\n  .agent-page .agent-edit__tb-group {\n    gap: 4px;\n  }\n\n  /* 2-pane 우측 패널(workflow/folder) → 풀스크린 오버레이 시트.\n     자체 헤더/닫기 버튼이 있어 독립적으로 닫힌다. 메인 채팅영역은 뒤에서 풀폭 유지. */\n  .agent-page .agent-chat__panel {\n    position: fixed;\n    inset: 0;\n    z-index: 150;\n    flex: none;\n    width: 100%;\n    max-width: 100%;\n    box-shadow: none;\n  }\n\n  /* 입력 영역 여백 축소 */\n  .agent-page .agent-chat__input-area {\n    padding: 10px 12px;\n  }\n\n  /* AgentCreate — 입력창 아래 예시(프리셋) 4개는 모바일에서 숨김 */\n  .agent-page .agent-create__presets {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
